var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNot3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "eCwuQE5mxSB1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 400 350",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    "project-id": "ddca1b1e70d24eeaaf1c9b009f779aed",
    "export-id": "25a144de8e0144e098a95d5628f045a2",
    cached: "false",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "eCwuQE5mxSB9-fill",
    x1: 1756.8,
    y1: 900.716,
    x2: 2601.342,
    y2: 434.132,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eCwuQE5mxSB9-fill-0",
    offset: "0%",
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eCwuQE5mxSB9-fill-1",
    offset: "95.3%",
    stopColor: "#ffba9f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eCwuQE5mxSB11-fill",
    x1: 1388.27,
    y1: 1354.89,
    x2: 2519.42,
    y2: 21.45,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eCwuQE5mxSB11-fill-0",
    offset: "0%",
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eCwuQE5mxSB11-fill-1",
    offset: "95.3%",
    stopColor: "#ffba9f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eCwuQE5mxSB12-fill",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eCwuQE5mxSB12-fill-0",
    offset: "0%",
    stopColor: "#ff9ff3"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eCwuQE5mxSB12-fill-1",
    offset: "100%",
    stopColor: "#ffd3bb"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eCwuQE5mxSB18-fill",
    x1: 2528.49,
    y1: 546.453,
    x2: 2265.793,
    y2: 926.628,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eCwuQE5mxSB18-fill-0",
    offset: "0%",
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eCwuQE5mxSB18-fill-1",
    offset: "53.2%",
    stopColor: "#fda47d"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eCwuQE5mxSB18-fill-2",
    offset: "66%",
    stopColor: "#e54053"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eCwuQE5mxSB18-fill-3",
    offset: "95.5%",
    stopColor: "#010019"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eCwuQE5mxSB20-fill",
    x1: 2360.97,
    y1: 577.908,
    x2: 2360.62,
    y2: 611.828,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eCwuQE5mxSB20-fill-0",
    offset: "21.6%",
    stopColor: "#ffb3cb"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eCwuQE5mxSB20-fill-1",
    offset: "85.2%",
    stopColor: "#e54053"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eCwuQE5mxSB23-fill",
    x1: 2254.08,
    y1: 1622.62,
    x2: 1984.705,
    y2: 1258.323,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eCwuQE5mxSB23-fill-0",
    offset: "0.5%",
    stopColor: "#aeaeba"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eCwuQE5mxSB23-fill-1",
    offset: "99.9%",
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eCwuQE5mxSB24-fill",
    x1: 2205.58,
    y1: 1335.96,
    x2: 1973.845,
    y2: 1390.457,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eCwuQE5mxSB24-fill-0",
    offset: "24.1%",
    stopColor: "#b5a3b7"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eCwuQE5mxSB24-fill-1",
    offset: "35.8%",
    stopColor: "#ccc4cc"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eCwuQE5mxSB24-fill-2",
    offset: "99.9%",
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eCwuQE5mxSB25-fill",
    x1: 2368.56,
    y1: 1607.95,
    x2: 1639.797,
    y2: 1014.982,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eCwuQE5mxSB25-fill-0",
    offset: "24.1%",
    stopColor: "#b5a3b7"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eCwuQE5mxSB25-fill-1",
    offset: "35.8%",
    stopColor: "#ccc4cc"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eCwuQE5mxSB25-fill-2",
    offset: "99.9%",
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eCwuQE5mxSB26-fill",
    x1: 2422.84,
    y1: 989.228,
    x2: 2138.088,
    y2: 1385.065,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eCwuQE5mxSB26-fill-0",
    offset: "24.1%",
    stopColor: "#b5a3b7"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eCwuQE5mxSB26-fill-1",
    offset: "35.8%",
    stopColor: "#ccc4cc"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eCwuQE5mxSB26-fill-2",
    offset: "99.9%",
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eCwuQE5mxSB27-fill",
    x1: 2432.09,
    y1: 1000.03,
    x2: 2153.399,
    y2: 1387.442,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eCwuQE5mxSB27-fill-0",
    offset: "24.1%",
    stopColor: "#b5a3b7"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eCwuQE5mxSB27-fill-1",
    offset: "35.8%",
    stopColor: "#ccc4cc"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eCwuQE5mxSB27-fill-2",
    offset: "99.9%",
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eCwuQE5mxSB28-fill",
    x1: 2273.26,
    y1: 1610.07,
    x2: 2021.084,
    y2: 1264.568,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eCwuQE5mxSB28-fill-0",
    offset: "0.5%",
    stopColor: "#aeaeba"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eCwuQE5mxSB28-fill-1",
    offset: "99.9%",
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eCwuQE5mxSB29-fill",
    x1: 2335.41,
    y1: 883.074,
    x2: 2254.003,
    y2: 1202.557,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eCwuQE5mxSB29-fill-0",
    offset: "35.8%",
    stopColor: "#ccc4cc"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eCwuQE5mxSB29-fill-1",
    offset: "99.9%",
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eCwuQE5mxSB30-fill",
    x1: 2216.59,
    y1: 1077.58,
    x2: 2160.539,
    y2: 1228.729,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eCwuQE5mxSB30-fill-0",
    offset: "7.3%",
    stopColor: "#8b758e"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eCwuQE5mxSB30-fill-1",
    offset: "25.5%",
    stopColor: "#b09db2"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eCwuQE5mxSB30-fill-2",
    offset: "99.9%",
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eCwuQE5mxSB31-fill",
    x1: 2308.28,
    y1: 929.914,
    x2: 2259.36,
    y2: 868.257,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eCwuQE5mxSB31-fill-0",
    offset: "0%",
    stopColor: "#d34f63"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eCwuQE5mxSB31-fill-1",
    offset: "99.5%",
    stopColor: "#ea8e67"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eCwuQE5mxSB32-fill",
    x1: 2341.79,
    y1: 1021.67,
    x2: 2332.896,
    y2: 1101.221,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eCwuQE5mxSB32-fill-0",
    offset: "32.5%",
    stopColor: "#d34f63"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eCwuQE5mxSB32-fill-1",
    offset: "99.5%",
    stopColor: "#ea8e67"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eCwuQE5mxSB33-fill",
    x1: 1916.55,
    y1: 1054.43,
    x2: 2143.621,
    y2: 1257.681,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eCwuQE5mxSB33-fill-0",
    offset: "0%",
    stopColor: "#ffcfa6"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eCwuQE5mxSB33-fill-1",
    offset: "69.1%",
    stopColor: "#ffb88c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eCwuQE5mxSB35-fill",
    x1: 2376.6,
    y1: 852.003,
    x2: 2328.088,
    y2: 787.947,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eCwuQE5mxSB35-fill-0",
    offset: "12.8%",
    stopColor: "#d34f63"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eCwuQE5mxSB35-fill-1",
    offset: "52.9%",
    stopColor: "#ed956e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eCwuQE5mxSB36-fill",
    x1: 2424.66,
    y1: 880.243,
    x2: 2214.31,
    y2: 729.789,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eCwuQE5mxSB36-fill-0",
    offset: "0%",
    stopColor: "#d34f63"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eCwuQE5mxSB36-fill-1",
    offset: "51.9%",
    stopColor: "#ea8e67"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eCwuQE5mxSB37-fill",
    x1: 2292.48,
    y1: 952.057,
    x2: 2229.166,
    y2: 894.353,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eCwuQE5mxSB37-fill-0",
    offset: "0%",
    stopColor: "#d34f63"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eCwuQE5mxSB37-fill-1",
    offset: "99.5%",
    stopColor: "#ea8e67"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eCwuQE5mxSB39-fill",
    x1: 2218.49,
    y1: 957.773,
    x2: 2163.103,
    y2: 907.293,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eCwuQE5mxSB39-fill-0",
    offset: "0%",
    stopColor: "#d34f63"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eCwuQE5mxSB39-fill-1",
    offset: "99.5%",
    stopColor: "#ea8e67"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eCwuQE5mxSB42-fill",
    x1: 2210.17,
    y1: 1017.71,
    x2: 2163.983,
    y2: 975.567,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eCwuQE5mxSB42-fill-0",
    offset: "32.5%",
    stopColor: "#d34f63"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eCwuQE5mxSB42-fill-1",
    offset: "85.6%",
    stopColor: "#ea8e67"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eCwuQE5mxSB43-fill",
    x1: 2099.29,
    y1: 1056.61,
    x2: 2216.195,
    y2: 1129.302,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eCwuQE5mxSB43-fill-0",
    offset: "32.5%",
    stopColor: "#d15050"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eCwuQE5mxSB43-fill-1",
    offset: "99.5%",
    stopColor: "#ea8e67"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eCwuQE5mxSB46-fill",
    x1: 2084.52,
    y1: 935.021,
    x2: 2171.163,
    y2: 925.069,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eCwuQE5mxSB46-fill-0",
    offset: "25.5%",
    stopColor: "#25254e"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eCwuQE5mxSB46-fill-1",
    offset: "100%",
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eCwuQE5mxSB47-fill",
    x1: 2176.85,
    y1: 877.572,
    x2: 2202.041,
    y2: 918.625,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eCwuQE5mxSB47-fill-0",
    offset: "25.5%",
    stopColor: "#25254e"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eCwuQE5mxSB47-fill-1",
    offset: "100%",
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eCwuQE5mxSB58-fill",
    x1: 2180.51,
    y1: 927.013,
    x2: 2205.924,
    y2: 948.941,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eCwuQE5mxSB58-fill-0",
    offset: "0%",
    stopColor: "#ffcfa6"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eCwuQE5mxSB58-fill-1",
    offset: "99.5%",
    stopColor: "#ffb88c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eCwuQE5mxSB60-fill",
    x1: 2207.38,
    y1: 999.015,
    x2: 2193.051,
    y2: 996.679,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eCwuQE5mxSB60-fill-0",
    offset: "0%",
    stopColor: "#d34f63"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eCwuQE5mxSB60-fill-1",
    offset: "99.5%",
    stopColor: "#ea8e67"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eCwuQE5mxSB68-fill",
    x1: 2115.21,
    y1: 951.482,
    x2: 2137.207,
    y2: 970.063,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eCwuQE5mxSB68-fill-0",
    offset: "0%",
    stopColor: "#ffcfa6"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eCwuQE5mxSB68-fill-1",
    offset: "99.5%",
    stopColor: "#ffb88c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eCwuQE5mxSB72-fill",
    x1: 2289.32,
    y1: 914.665,
    x2: 2244.6,
    y2: 891.78,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eCwuQE5mxSB72-fill-0",
    offset: "1.9%",
    stopColor: "#d65764"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eCwuQE5mxSB72-fill-1",
    offset: "63%",
    stopColor: "#ffc6a6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eCwuQE5mxSB75-fill",
    x1: 2103.52,
    y1: 814.662,
    x2: 2175.898,
    y2: 814.662,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eCwuQE5mxSB75-fill-0",
    offset: "5.6%",
    stopColor: "#ffddc9"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eCwuQE5mxSB75-fill-1",
    offset: "77.1%",
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eCwuQE5mxSB76-fill",
    x1: 2100.67,
    y1: 1309.07,
    x2: 2265.237,
    y2: 1309.07,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eCwuQE5mxSB76-fill-0",
    offset: "0%",
    stopColor: "#ffcfa6"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eCwuQE5mxSB76-fill-1",
    offset: "100%",
    stopColor: "#ffb88c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eCwuQE5mxSB77-fill",
    x1: 2100.67,
    y1: 1339.41,
    x2: 2265.237,
    y2: 1339.41,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eCwuQE5mxSB77-fill-0",
    offset: "0%",
    stopColor: "#ffcfa6"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eCwuQE5mxSB77-fill-1",
    offset: "80.7%",
    stopColor: "#e27966"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eCwuQE5mxSB78-fill",
    x1: 2261.06,
    y1: 1388.86,
    x2: 2217.209,
    y2: 1357.125,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eCwuQE5mxSB78-fill-0",
    offset: "1.8%",
    stopColor: "#d34f63"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eCwuQE5mxSB78-fill-1",
    offset: "100%",
    stopColor: "#e27966"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eCwuQE5mxSB84-fill",
    x1: 2042.72,
    y1: 1070.84,
    x2: 2188.608,
    y2: 941.328,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eCwuQE5mxSB84-fill-0",
    offset: "35.8%",
    stopColor: "#ccc4cc"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eCwuQE5mxSB84-fill-1",
    offset: "99.9%",
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eCwuQE5mxSB91-fill",
    x1: 2278.99,
    y1: 1337.98,
    x2: 1896.206,
    y2: 1061.444,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eCwuQE5mxSB91-fill-0",
    offset: "5.1%",
    stopColor: "#a08ba2"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eCwuQE5mxSB91-fill-1",
    offset: "35.8%",
    stopColor: "#ccc4cc"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eCwuQE5mxSB91-fill-2",
    offset: "99.9%",
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eCwuQE5mxSB92-fill",
    x1: 1657.85,
    y1: 2196.91,
    x2: 1276.975,
    y2: 1921.753,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eCwuQE5mxSB92-fill-0",
    offset: "5.1%",
    stopColor: "#a08ba2"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eCwuQE5mxSB92-fill-1",
    offset: "35.8%",
    stopColor: "#ccc4cc"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eCwuQE5mxSB92-fill-2",
    offset: "99.9%",
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eCwuQE5mxSB93-fill",
    x1: 2247.99,
    y1: 1406.85,
    x2: 1642.778,
    y2: 969.625,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eCwuQE5mxSB93-fill-0",
    offset: "5.1%",
    stopColor: "#a08ba2"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eCwuQE5mxSB93-fill-1",
    offset: "35.8%",
    stopColor: "#ccc4cc"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eCwuQE5mxSB93-fill-2",
    offset: "99.9%",
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eCwuQE5mxSB94-fill",
    x1: 1410.59,
    y1: 2534.79,
    x2: 1035.79,
    y2: 2264.022,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eCwuQE5mxSB94-fill-0",
    offset: "5.1%",
    stopColor: "#a08ba2"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eCwuQE5mxSB94-fill-1",
    offset: "35.8%",
    stopColor: "#ccc4cc"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eCwuQE5mxSB94-fill-2",
    offset: "99.9%",
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eCwuQE5mxSB96-fill",
    x1: 2307.59,
    y1: 1388.15,
    x2: 2235.522,
    y2: 1358.032,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eCwuQE5mxSB96-fill-0",
    offset: "0.5%",
    stopColor: "#aeaeba"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eCwuQE5mxSB96-fill-1",
    offset: "99.9%",
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eCwuQE5mxSB97-fill",
    x1: 2429.32,
    y1: 1064.55,
    x2: 2104.72,
    y2: 1417.057,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eCwuQE5mxSB97-fill-0",
    offset: "7.3%",
    stopColor: "#8b758e"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eCwuQE5mxSB97-fill-1",
    offset: "25.5%",
    stopColor: "#b09db2"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eCwuQE5mxSB97-fill-2",
    offset: "99.9%",
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eCwuQE5mxSB98-fill",
    x1: 2291.21,
    y1: 1401.55,
    x2: 2178.987,
    y2: 1302.152,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eCwuQE5mxSB98-fill-0",
    offset: "7.3%",
    stopColor: "#8b758e"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eCwuQE5mxSB98-fill-1",
    offset: "53.4%",
    stopColor: "#b09db2"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eCwuQE5mxSB98-fill-2",
    offset: "99.9%",
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eCwuQE5mxSB100-fill",
    x1: 1959.39,
    y1: 1288.42,
    x2: 2066.22,
    y2: 1288.42,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eCwuQE5mxSB100-fill-0",
    offset: "0%",
    stopColor: "#ffcfa6"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eCwuQE5mxSB100-fill-1",
    offset: "100%",
    stopColor: "#ffb88c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eCwuQE5mxSB101-fill",
    x1: 2175.92,
    y1: 1244.04,
    x2: 1928.757,
    y2: 1444.892,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eCwuQE5mxSB101-fill-0",
    offset: "0%",
    stopColor: "#ffcfa6"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eCwuQE5mxSB101-fill-1",
    offset: "100%",
    stopColor: "#e27966"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eCwuQE5mxSB102-fill",
    x1: 2002.31,
    y1: 1288.42,
    x2: 2066.225,
    y2: 1288.42,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eCwuQE5mxSB102-fill-0",
    offset: "1.8%",
    stopColor: "#d34f63"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eCwuQE5mxSB102-fill-1",
    offset: "100%",
    stopColor: "#e27966"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eCwuQE5mxSB103-fill",
    x1: 2187.69,
    y1: 1424.31,
    x2: 1997.451,
    y2: 1321.005,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eCwuQE5mxSB103-fill-0",
    offset: "0.5%",
    stopColor: "#aeaeba"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eCwuQE5mxSB103-fill-1",
    offset: "99.9%",
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eCwuQE5mxSB104-fill",
    x1: 2087.24,
    y1: 1377.4,
    x2: 1891.229,
    y2: 1228.665,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eCwuQE5mxSB104-fill-0",
    offset: "16.4%",
    stopColor: "#8b758e"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eCwuQE5mxSB104-fill-1",
    offset: "40.2%",
    stopColor: "#b09db2"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eCwuQE5mxSB104-fill-2",
    offset: "99.9%",
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eCwuQE5mxSB106-fill",
    x1: 1939.73,
    y1: 1330.68,
    x2: 1985.148,
    y2: 1330.68,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eCwuQE5mxSB106-fill-0",
    offset: "32.5%",
    stopColor: "#d34f63"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eCwuQE5mxSB106-fill-1",
    offset: "99.5%",
    stopColor: "#ea8e67"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eCwuQE5mxSB107-fill",
    x1: 1929.48,
    y1: 1324.92,
    x2: 1998.697,
    y2: 1324.92,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eCwuQE5mxSB107-fill-0",
    offset: "0%",
    stopColor: "#ffcfa6"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eCwuQE5mxSB107-fill-1",
    offset: "69.1%",
    stopColor: "#ffb88c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eCwuQE5mxSB108-fill",
    x1: 1938.33,
    y1: 1366.96,
    x2: 1994.282,
    y2: 1335.831,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eCwuQE5mxSB108-fill-0",
    offset: "32.5%",
    stopColor: "#d34f63"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eCwuQE5mxSB108-fill-1",
    offset: "99.5%",
    stopColor: "#ea8e67"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eCwuQE5mxSB109-fill",
    x1: 1965.94,
    y1: 1349.26,
    x2: 1998.706,
    y2: 1349.26,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eCwuQE5mxSB109-fill-0",
    offset: "0%",
    stopColor: "#d34f63"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eCwuQE5mxSB109-fill-1",
    offset: "86%",
    stopColor: "#ea8e67"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eCwuQE5mxSB115-fill",
    x1: 1947.78,
    y1: 1329.52,
    x2: 1986.807,
    y2: 1329.52,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eCwuQE5mxSB115-fill-0",
    offset: "0%",
    stopColor: "#d34f63"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eCwuQE5mxSB115-fill-1",
    offset: "86%",
    stopColor: "#ea8e67"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eCwuQE5mxSB116-fill",
    x1: 1948.89,
    y1: 1369.76,
    x2: 1962.833,
    y2: 1324.058,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eCwuQE5mxSB116-fill-0",
    offset: "0%",
    stopColor: "#010019"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eCwuQE5mxSB116-fill-1",
    offset: "63.7%",
    stopColor: "#a31d2d"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eCwuQE5mxSB116-fill-2",
    offset: "94.4%",
    stopColor: "#c93d47"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eCwuQE5mxSB120-fill",
    x1: 1861.34,
    y1: 1636.86,
    x2: 1741.13,
    y2: 699.929,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eCwuQE5mxSB120-fill-0",
    offset: "10.5%",
    stopColor: "#010019"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eCwuQE5mxSB120-fill-1",
    offset: "98.9%",
    stopColor: "#787282"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eCwuQE5mxSB122-fill",
    x1: 1534.62,
    y1: 1399.1,
    x2: 1480.999,
    y2: 1044.215,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eCwuQE5mxSB122-fill-0",
    offset: "10.5%",
    stopColor: "#010019"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eCwuQE5mxSB122-fill-1",
    offset: "98.9%",
    stopColor: "#787282"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eCwuQE5mxSB133-fill",
    x1: 1774.43,
    y1: 1528.71,
    x2: 1898.586,
    y2: 1191.216,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eCwuQE5mxSB133-fill-0",
    offset: "0.5%",
    stopColor: "#aeaeba"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eCwuQE5mxSB133-fill-1",
    offset: "99.9%",
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eCwuQE5mxSB134-fill",
    x1: 1890.02,
    y1: 1595.86,
    x2: 2015.927,
    y2: 1253.604,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eCwuQE5mxSB134-fill-0",
    offset: "0.5%",
    stopColor: "#aeaeba"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eCwuQE5mxSB134-fill-1",
    offset: "99.9%",
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eCwuQE5mxSB135-fill",
    x1: 1679.77,
    y1: 1354.45,
    x2: 2666.86,
    y2: 1354.45,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eCwuQE5mxSB135-fill-0",
    offset: "15.5%",
    stopColor: "#ffd1c0"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eCwuQE5mxSB135-fill-1",
    offset: "97.8%",
    stopColor: "#f05960"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eCwuQE5mxSB137-fill",
    x1: 2147.56,
    y1: 1288.88,
    x2: 2585.437,
    y2: 1443.341,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eCwuQE5mxSB137-fill-0",
    offset: "15.5%",
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eCwuQE5mxSB137-fill-1",
    offset: "86.3%",
    stopColor: "#ffba9f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eCwuQE5mxSB152-fill",
    x1: 1740.89,
    y1: 786.029,
    x2: 1962.358,
    y2: 786.029,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eCwuQE5mxSB152-fill-0",
    offset: "0.1%",
    stopColor: "#fec045"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eCwuQE5mxSB152-fill-1",
    offset: "100%",
    stopColor: "#f47555"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eCwuQE5mxSB158-fill",
    x1: 2643.85,
    y1: 1265.33,
    x2: 2572.464,
    y2: 1348.157,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eCwuQE5mxSB158-fill-0",
    offset: "42.4%",
    stopColor: "#f37753"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eCwuQE5mxSB158-fill-1",
    offset: "62.8%",
    stopColor: "#d85335"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eCwuQE5mxSB158-fill-2",
    offset: "97.1%",
    stopColor: "#951a2b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eCwuQE5mxSB160-fill",
    x1: 2242.35,
    y1: 1310.65,
    x2: 2251.785,
    y2: 1112.51,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eCwuQE5mxSB160-fill-0",
    offset: "6.2%",
    stopColor: "#f3d5c7"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eCwuQE5mxSB160-fill-1",
    offset: "100%",
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eCwuQE5mxSB162-fill",
    x1: 2465.12,
    y1: 1290.16,
    x2: 2554.638,
    y2: 1290.16,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eCwuQE5mxSB162-fill-0",
    offset: "0.1%",
    stopColor: "#fec045"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eCwuQE5mxSB162-fill-1",
    offset: "100%",
    stopColor: "#f47555"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eCwuQE5mxSB163-fill",
    x1: 2476.98,
    y1: 1290.19,
    x2: 2554.609,
    y2: 1290.19,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eCwuQE5mxSB163-fill-0",
    offset: "42.4%",
    stopColor: "#f37753"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eCwuQE5mxSB163-fill-1",
    offset: "99.9%",
    stopColor: "#d85335"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eCwuQE5mxSB164-fill",
    x1: 2487.7,
    y1: 1255.7,
    x2: 2515.727,
    y2: 1313.674,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eCwuQE5mxSB164-fill-0",
    offset: "0.5%",
    stopColor: "#faa24b"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eCwuQE5mxSB164-fill-1",
    offset: "3.5%",
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eCwuQE5mxSB164-fill-2",
    offset: "100%",
    stopColor: "#ffce94"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eCwuQE5mxSB167-fill",
    x1: 2441.05,
    y1: 912.757,
    x2: 2576.154,
    y2: 912.757,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eCwuQE5mxSB167-fill-0",
    offset: "0.1%",
    stopColor: "#fec045"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eCwuQE5mxSB167-fill-1",
    offset: "100%",
    stopColor: "#f47555"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eCwuQE5mxSB182-fill",
    x1: 2508.14,
    y1: 879.359,
    x2: 2640.598,
    y2: 879.359,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eCwuQE5mxSB182-fill-0",
    offset: "0.1%",
    stopColor: "#fec045"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eCwuQE5mxSB182-fill-1",
    offset: "100%",
    stopColor: "#f47555"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eCwuQE5mxSB199-fill",
    x1: 2004.28,
    y1: 775.794,
    x2: 1843.388,
    y2: 1027.468,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eCwuQE5mxSB199-fill-0",
    offset: "0%",
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eCwuQE5mxSB199-fill-1",
    offset: "53.2%",
    stopColor: "#fda47d"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eCwuQE5mxSB199-fill-2",
    offset: "66%",
    stopColor: "#e54053"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eCwuQE5mxSB199-fill-3",
    offset: "95.5%",
    stopColor: "#010019"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eCwuQE5mxSB200-fill",
    x1: 1968.62,
    y1: 720.326,
    x2: 1796.299,
    y2: 989.879,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eCwuQE5mxSB200-fill-0",
    offset: "0%",
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eCwuQE5mxSB200-fill-1",
    offset: "53.2%",
    stopColor: "#fda47d"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eCwuQE5mxSB200-fill-2",
    offset: "66%",
    stopColor: "#e54053"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eCwuQE5mxSB200-fill-3",
    offset: "95.5%",
    stopColor: "#010019"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eCwuQE5mxSB201-fill",
    x1: 1987.99,
    y1: 740.582,
    x2: 1815.669,
    y2: 1010.134,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eCwuQE5mxSB201-fill-0",
    offset: "0%",
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eCwuQE5mxSB201-fill-1",
    offset: "53.2%",
    stopColor: "#fda47d"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eCwuQE5mxSB201-fill-2",
    offset: "66%",
    stopColor: "#e54053"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eCwuQE5mxSB201-fill-3",
    offset: "95.5%",
    stopColor: "#010019"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eCwuQE5mxSB202-fill",
    x1: 1987.99,
    y1: 740.582,
    x2: 1815.669,
    y2: 1010.134,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eCwuQE5mxSB202-fill-0",
    offset: "0%",
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eCwuQE5mxSB202-fill-1",
    offset: "53.2%",
    stopColor: "#fda47d"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eCwuQE5mxSB202-fill-2",
    offset: "66%",
    stopColor: "#e54053"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eCwuQE5mxSB202-fill-3",
    offset: "95.5%",
    stopColor: "#010019"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eCwuQE5mxSB203-fill",
    x1: 2007.36,
    y1: 760.837,
    x2: 1835.039,
    y2: 1030.389,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eCwuQE5mxSB203-fill-0",
    offset: "0%",
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eCwuQE5mxSB203-fill-1",
    offset: "53.2%",
    stopColor: "#fda47d"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eCwuQE5mxSB203-fill-2",
    offset: "66%",
    stopColor: "#e54053"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eCwuQE5mxSB203-fill-3",
    offset: "95.5%",
    stopColor: "#010019"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eCwuQE5mxSB204-fill",
    x1: 2007.36,
    y1: 760.837,
    x2: 1835.039,
    y2: 1030.389,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eCwuQE5mxSB204-fill-0",
    offset: "0%",
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eCwuQE5mxSB204-fill-1",
    offset: "53.2%",
    stopColor: "#fda47d"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eCwuQE5mxSB204-fill-2",
    offset: "66%",
    stopColor: "#e54053"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eCwuQE5mxSB204-fill-3",
    offset: "95.5%",
    stopColor: "#010019"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eCwuQE5mxSB205-fill",
    x1: 2026.73,
    y1: 781.091,
    x2: 1854.409,
    y2: 1050.643,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eCwuQE5mxSB205-fill-0",
    offset: "0%",
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eCwuQE5mxSB205-fill-1",
    offset: "53.2%",
    stopColor: "#fda47d"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eCwuQE5mxSB205-fill-2",
    offset: "66%",
    stopColor: "#e54053"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eCwuQE5mxSB205-fill-3",
    offset: "95.5%",
    stopColor: "#010019"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.359155 0 0 0.357333-612.384322-168.628091)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-39.723942-69.97504)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(110.547882-8.8543)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2243.6,798.6c15.9,8.6,32.2,14.6,48.9,18.7c16.7,4,33.8,6.2,51.5,7.2q.2,0,.4.1.1,0,.3,0c22.9,1.2,47.6-1.3,69.2-9.9c21.6-8.5,40-23.1,50.2-45.9c5-11.1,6.5-22.6,5.1-33.7-1.3-11.2-5.6-22.1-12.1-32.1-6.4-10-14.6-17.7-24.1-23.2-9.4-5.5-20.2-8.9-31.8-10.5q-.8-.1-1.5-.2-.8-.1-1.5-.1c-9.3-1-18.7-1.2-28.1-1.6s-18.7-1.1-27.8-3.1c-11.1-2.4-21.6-6.7-31.8-11.7s-20.1-10.7-30.2-15.9c-13.6-7.1-30.7-11.4-47.4-11-16.7.5-32.9,5.7-44.7,17.5-9.6,9.7-13.9,23.2-14.8,37.4-.8,14.2,1.9,29,6.4,41c6.2,16.4,14.7,31.6,25.3,44.7c10.7,13.1,23.6,24.2,38.5,32.3Z",
    fill: "url(#eCwuQE5mxSB9-fill)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2675.7,1001.6c-8.4-21.5-20-42.2-34.7-60s-32.6-32.6-53.8-42.2c-19.6-9-40.8-12.9-62.4-14.9s-43.7-2.1-65.4-3.2c-49.9-2.8-99.5-12.1-146.8-28s-92.2-38.5-132.7-67.6c-27.6-19.9-53.8-43.1-81.2-63.5-27.5-20.3-56.4-37.8-89.5-46.2-42.2-10.8-86.3-4.5-125.8,13.7-39.5,18.1-74.4,48-98.3,84.2-23.9,36.1-38.1,77.2-44.9,119.9s-6.1,87.1-.2,129.9q.4,2.9.8,5.7.5,2.9,1,5.7q3.4,21.2,8.6,42t12.1,41.2q7,20.3,15.6,40q8.7,19.7,19,38.6q10.3,18.7,22.2,36.4q11.9,17.8,25.5,34.4c8.9,10.9,18.4,21.3,28.4,31.3c10,9.9,20.5,19.4,31.5,28.2c7.5,6,15.4,11.6,23.5,16.7s16.5,9.8,25.2,14.2h292.6h292.6c24.8-14.5,47.9-31.5,68.2-51.2c20.4-19.6,38-41.9,52.2-66.9c20.2-35.9,32-76.3,34.8-117.4c2.9-41-3-82.7-18.1-121Z",
    fill: "url(#eCwuQE5mxSB11-fill)"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M1717.3,915.5q-.3,0-.7,0-.3,0-.6,0",
    fill: "url(#eCwuQE5mxSB12-fill)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.784313 0)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2472.6,715.9l-90.837252,3.7-111.184313-3.7c-8.3,0-1.878435-3.3-7.278435-8.7s-8.7-12.9-8.7-21.2v-28.9-28.9c0-8.3,3.3-15.8,8.7-21.2s12.9-8.7,21.2-8.7h94h94.1c8.3,0,15.8,3.3,21.2,8.7s8.7,12.9,8.7,21.2v28.9v28.9c0,8.3-3.3,15.8-8.7,21.2s-12.9,8.7-21.2,8.7Z",
    transform: "translate(2.815687-3.499999)",
    opacity: 0.6,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2502.5,661.6v12.2v12.3c0,8.2-3.3,15.6-8.7,21.1-5.4,5.4-12.9,8.7-21.1,8.7h-94.1-94.1c-8.3,0-15.8-3.3-21.2-8.7-5.4-5.5-8.8-12.9-8.8-21.1v-12.3-12.2c0,5.3,1.4,10.3,3.9,14.6c2.4,4.3,5.9,8,10.1,10.6v4v4c0,2.5,1,4.7,2.7,6.4c1.6,1.6,3.9,2.7,6.4,2.7h12.8h12.7c2.5,0,4.7-1.1,6.3-2.7c1.7-1.7,2.7-3.9,2.7-6.4v-1.7-1.7h80.3h80.3c8.2,0,15.7-3.3,21.1-8.7s8.7-12.9,8.7-21.1Z",
    opacity: 0.4,
    fill: "#fcbba7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2500.8,695.8h14.3h14.2v-34-34h-14.2-14.3v34v34Z",
    fill: "#fda47d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2472.6,719.4h-188.1c-9.2,0-17.6-3.7-23.6-9.8-6.1-6-9.8-14.4-9.8-23.6v-57.8c0-9.2,3.7-17.6,9.8-23.6c6-6.1,14.4-9.8,23.6-9.8h188.1c9.2,0,17.6,3.7,23.6,9.8c6.1,6,9.8,14.4,9.8,23.6v57.8c0,9.2-3.7,17.6-9.8,23.6-6,6.1-14.4,9.8-23.6,9.8ZM2284.5,601.7c-7.3,0-13.9,3-18.7,7.8s-7.8,11.4-7.8,18.7v57.8c0,7.3,3,13.9,7.8,18.7s11.4,7.8,18.7,7.8h188.1c7.3,0,13.9-3,18.7-7.8s7.8-11.4,7.8-18.7v-57.8c0-7.3-3-13.9-7.8-18.7s-11.4-7.8-18.7-7.8h-188.1Z",
    fill: "url(#eCwuQE5mxSB18-fill)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "eCwuQE5mxSB19",
    opacity: 0
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2312.1,622.6v34.4v34.4h-13.8-13.8c-3,0-5.8-.4-8.5-1.2-2.7-.7-5.2-1.9-7.5-3.4v-32.1-32.1c0-2.5,1-4.7,2.7-6.3c1.6-1.7,3.9-2.7,6.4-2.7h12.8h12.7c2.5,0,4.7,1,6.3,2.7c1.7,1.6,2.7,3.8,2.7,6.3Z",
    fill: "url(#eCwuQE5mxSB20-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2312.1,691.4v1.7v1.7c0,2.5-1,4.7-2.7,6.4-1.6,1.6-3.8,2.7-6.3,2.7h-12.7-12.8c-2.5,0-4.8-1.1-6.4-2.7-1.7-1.7-2.7-3.9-2.7-6.4v-4-4c2.3,1.5,4.8,2.7,7.5,3.4c2.7.8,5.5,1.2,8.5,1.2h13.8h13.8Z",
    fill: "#a31d2d"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2402.2,1228.7q-.3,13-1.8,25.8-1.6,12.9-4.2,25.5-.8,3.4-1.6,6.9-.8,3.4-1.7,6.8c-2.6,9.9-5.5,20.3-9.2,30.4-3.6,10-8.1,19.7-13.9,28.3-.6.8-1.1,1.7-1.7,2.5s-1.3,1.5-2.1,1.9c-1.1.5-2.5.7-3.8.7s-2.7-.2-3.8-.3c-16.9-1.8-33.5-2.3-50.1-2.2s-33.2.8-50.1,1.8c-2,.1-3.4.3-5.3.5-2,.2-4.4.5-8.4.8c1.4-2.6,3.4-4.9,5.1-7.4c1.6-2.5,3.1-5,3.5-8c.3-2.3.3-4.8-.1-7.1-.4-2.4-1.1-4.7-2.1-6.9-.9-2.2-2.2-4.3-3.7-6.2s-3.3-3.6-5.3-5.1c-.4-.3-3.5-1.7-6.5-2.8-3-1.2-5.9-2.1-5.9-1.3.5,7.3-.2,14.6-1.9,21.7-1.6,7.1-4.1,14-6.9,20.8-9.2-.5-18.4-.7-27.5-.7-9.2,0-18.4.2-27.6.4q-6.9.2-13.8.5t-13.8.6q-3.5.2-6.9.4-3.5.2-7,.3c-1.6.1-3.3.4-4.9.5s-3.2-.1-4.7-1.1c1.1-4.3,2.2-8.7,3-13.1s1.4-8.9,1.4-13.5q.5-6.8.9-13.7.5-6.8,1-13.6v-.3-.2q.1-1.3.2-2.5t.1-2.4q-.1.1-.3.2-.1.1-.3.3-.3.2-.6.4-.4.2-.7.4c-5.3,4.1-10.8,7.9-16.4,11.4-5.7,3.5-11.4,6.7-17.4,9.9q.2-1.9.2-3.7q0-1.9-.2-3.8-.2-1.4-.5-2.8t-.7-2.8q0-.1-.1-.2q0-.1,0-.2-.6-1.9-1.4-3.7t-1.9-3.5c-1.3-2.3-2.9-4.3-4.7-6.3-1.8-1.9-3.8-3.6-5.8-5.3-4-3-8-5.1-12.3-6.2-4.2-1.1-8.7-1.2-13.7-.4-5.2.9-10.5,2.2-15.7,3.5-5.2,1.2-10.4,2.4-15.8,2.9c1-.1,4.6-4.7,8.3-9.4c3.7-4.8,7.4-9.9,8.3-11q5.5-6.1,10.7-12.5t10.3-12.9c3.1-4.1,6.2-8.3,9-12.6c2.7-4.3,5.3-8.8,7.2-13.6c2.3-5.4,5.2-12,8-18.6s5.3-13.2,7-18.9c6-21,11.5-38.9,17.1-53.9c5.7-14.9,11.5-26.8,18.2-35.6c2.5-3.3,5.4-6.3,8.6-9.1c3.1-2.8,6.5-5.4,10-7.9q7.1-5.2,14.9-9.4q7.7-4.2,15.9-7.5q1-.4,2.2-1.1t2.5-1.6h.1c2.7-1.7,5.7-3.9,8.5-5.8c2.9-1.9,5.6-3.5,7.7-4.1c2.1-.7,4.9-1.8,7.7-2.7s5.7-1.6,7.8-1.1c-1.1,4.3-2.2,8.3-3,12.7-.9,4.4-1.6,9.2-2,14.9-.4,4.4-.1,8.4.5,12.3s1.5,7.7,2.6,12.1q1.1,4.2,2,8.4q1,4.2,1.7,8.4.1,0,.1.1.1.1,0,.1.6,2.8,1.1,5.5.5,2.8,1,5.6-.1-1.5-.1-3q.1-1.5.4-2.9q0-.5.1-1t.2-.9q.3-1.9.9-3.8.7-1.8,1.6-3.5c1-2.1,2.3-4,3.7-5.8c1.5-1.9,3-3.6,4.6-5.4c3.3-3.7,6.7-7.5,10.3-11.1c3.6-3.5,7.4-6.9,11.4-10c2.9-2.3,6-4.4,9.1-6.5c3-2.2,5.9-4.4,8.7-7c1.3-1.1,2.6-2.5,3.8-3.9s2.4-2.9,3.3-4.5c1.4-2.5,3.1-5.7,4.5-8.4s2.4-4.7,2.4-4.7c0,.3.6.4,1.6.6c1,.1,2.4.2,4,.2c3.2,0,7.3-.3,10.5-.7c3.3-.4,5.8-1,5.8-1.6.2-2.9.4-5.8.6-8.7.1-2.9.3-5.7.3-8.5c1.8,2.2,4.1,4.1,6.5,6c2.5,1.9,5.1,3.6,7.7,5.3q1.7,1.2,3.4,2.3q1.6,1.1,3.1,2.3q5.8,4.7,11.5,9.4q5.7,4.8,11.3,9.7c6.1,5.4,11.9,11.2,17.4,17.2c5.4,6.1,10.5,12.5,15.2,19.2c4.5,6.6,8.2,13.5,11.2,20.7s5.5,14.6,7.8,22.3c4.7,15.8,8.1,31.8,10.2,48.1s3,32.7,2.4,49Z",
    fill: "url(#eCwuQE5mxSB23-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2120.5,1297.9q-.3.2-.6.4-.4.2-.7.4c-5.3,4.1-10.8,7.9-16.4,11.4-5.7,3.5-11.4,6.7-17.4,9.9q.2-1.9.2-3.7q0-1.9-.2-3.8c.7-1.2.8-1.8.9-2.4c0-.5.2-1,1.2-2.1l-1.7-.6-1.6-.5h-.4l-.4.1q.2-.1.3-.2.2-.1.4-.3c8.3-5.6,15.4-13.1,21.4-28c5.9-14.8,10.7-37.1,14.3-72.3.2,6.2.8,26.1,1.1,45.9.4,19.8.4,39.6-.4,45.8Z",
    fill: "url(#eCwuQE5mxSB24-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2398.8,1281.2q-.3,1-.5,2.1-.2,1-.5,2.1c-1.3,5.9-2.9,11-4.5,16-1.7,5.1-3.5,10.1-5.3,15.9-1.3,4.3-3,8.6-4.9,12.8-1.8,4.2-3.9,8.3-6,12.3q-1.6,3.2-3.4,6.2-1.7,3.1-3.7,6-.6.9-1.2,1.8t-1.3,1.7h-127.5-127.4c1.5-5.3,3.1-10.9,4.3-15.9c1.1-5,2-9.3,2-12.1.3-4.6.4-6.2.5-7.8.1-1.7.2-3.3.6-7.9c13.4,1,27.1,1.2,39.6.9c12.6-.4,24.2-1.2,33.5-2.3q5-.6,9.6-1.5q4.6-1,8.8-2.3.6-.2,1.2-.4t1.2-.4c16-5.6,27.7-15.5,36.3-29.4s14.1-31.8,17.8-53.6q.1-.5.1-1.1.1-.5.2-1.1q1.8-11.3,3-24t2-26.6q.1-.6.1-1.1q0-.6.1-1.2.1-1.9.2-3.9t.2-4q0-.6,0-1.1.1-.6.1-1.2c.8-17.7,1.3-36.9,1.7-57.5.5-20.6.9-42.6,1.6-65.9c3.2,0,7.3-.3,10.5-.7c3.3-.4,5.8-1,5.8-1.6.2-2.9.4-5.8.6-8.7.1-2.9.3-5.7.3-8.5c2.6,3.2,6.1,5.9,9.9,8.4c3.7,2.6,7.5,4.9,10.8,7.5q5.8,4.7,11.5,9.4q5.7,4.8,11.3,9.7c13.4,12,24.8,24.6,34.1,38.6c9.2,13.9,16.4,29.2,21.4,46.6c3.5,11.8,6.3,23.7,8.4,35.7c2.1,12.1,3.5,24.2,4.1,36.5.5,11.8-.1,24.1-1.4,36.2s-3.4,24.1-5.8,35.4Z",
    fill: "url(#eCwuQE5mxSB25-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2200.9,1090.1q1.1,4.3,2,8.5q1,4.2,1.7,8.4-.4-1.1-.9-2.2t-1-2.2q-3.4,8.7-7.8,17-4.5,8.3-9.9,16c-5.4-7.8-9.5-16.4-12.2-25.4-2.7-9.1-4.2-18.5-4.4-28-.1-4.8,0-9.8.5-14.9.4-5.1,1.1-10.3,2.1-15.4h.1c2.6-1.7,5.7-3.9,8.5-5.8c2.9-1.9,5.6-3.6,7.7-4.1c2.1-.7,4.9-1.8,7.7-2.7s5.6-1.6,7.8-1.1c-1.1,4.3-2.2,8.3-3,12.7-.9,4.4-1.6,9.1-2,14.9-.4,4.4-.2,8.4.5,12.3.6,3.9,1.5,7.7,2.6,12Z",
    fill: "url(#eCwuQE5mxSB26-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2308.7,1028.5q-.1,3.8-.4,7.5t-.9,7.4c-1.4,9.5-3.7,18.9-7.2,27.9-3.5,8.9-8.3,17.3-14.5,24.5-3.1,3.6-6.6,6.9-10.2,10s-7.5,6-11.3,8.8c-7.2,5.3-14.7,10.3-22.5,14.6s-15.9,8-24.5,10.4q-2.2-6.9-4.7-13.7-2.6-6.9-5.4-13.6q0-.4.1-.9t.2-.9q.3-1.9.9-3.8.7-1.8,1.6-3.5c1-2.1,2.3-4,3.7-5.8c1.4-1.9,3-3.6,4.5-5.4c3.4-3.7,6.8-7.5,10.4-11.1s7.3-6.9,11.4-10c2.9-2.3,6-4.4,9-6.5c3.1-2.2,6-4.4,8.8-7c1.3-1.1,2.6-2.5,3.8-3.9s2.4-2.9,3.3-4.5c1.3-2.5,3.1-5.7,4.5-8.4s2.4-4.7,2.4-4.7c0,.2.6.4,1.6.6c1,.1,2.4.2,4,.2c3.2,0,7.3-.3,10.5-.7c3.3-.4,5.8-1,5.8-1.6.2-2.9.4-5.8.6-8.7.1-2.9.3-5.7.3-8.6c1.8,2.3,4.1,4.2,6.5,6.1c2.5,1.8,5.1,3.6,7.7,5.3Z",
    fill: "url(#eCwuQE5mxSB27-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2308,1148.9c-2.1,8.5-3.1,17.2-3.6,25.9-.4,8.8-.4,17.6-.3,26.3q.2,10.9.3,21.8.1,10.8.2,21.7.1,5.4.1,10.9.1,5.4.1,10.8.1,2.7.1,5.5q0,2.7,0,5.4.1,1.3.1,2.6t0,2.6c0,.8.2,1.8.2,2.9.1,1,.1,2.1-.1,2.8-.3.8-1.1,1.1-1.9,1.1-.9.1-2-.1-2.8,0q-1.6.1-3.2.2t-3.2.3q-3.1.3-6.2.9-3.2.5-6.3,1.2-6.2,1.4-12.2,3.5t-11.7,4.9q-.5.3-1,.6t-.8.8c-.3.5-.4,1-.4,1.5.1.5.2,1,.4,1.4q.4.7.9,1.2.5.6,1.1,1.1c1.7,1.6,3.2,3.3,4.7,5.2c1.4,1.8,2.7,3.8,3.7,5.9c1,2,1.5,4.4,2,6.7.6,2.3,1.2,4.6,2.5,6.4c1.1,1.6,2.8,2.7,4.6,3.3c1.8.7,3.9.8,5.8.6c8.2-1.3,15.1-2.3,22-3.6c7-1.4,14-3.1,22.3-5.7c10.9-3.4,17.1-6.4,21-9.8c4-3.4,5.7-7.3,7.5-12.4c3.1-8.5,5.3-20.7,7-34.9s2.8-30.5,3.7-47.4c.7-14.4.4-28.6-.9-42.9-1.2-14.3-3.4-28.7-6.3-43.5-.7-3.5-1.2-6.7-2-9.8-.7-3-1.8-6-3.5-9.2-7.8-14.4-18-9.4-26.6.9-8.6,10.2-15.7,25.7-17.3,32.3Z",
    fill: "url(#eCwuQE5mxSB28-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2206.6,1120.5c-.7-5.1-2.2-10.2-4.3-15-2.2-4.8-5.1-9.2-8.7-13q-.6-.6-1.2-1-.6-.5-1.2-1q0,.1,0,.2-.1,0-.1.2c-1,4.6-2.7,9-4.9,13.2s-4.9,8-8.2,11.5c-2.7-4.1-5-8.5-6.9-13.1-1.9-4.7-3.4-9.5-4.5-14.5q-.4-1.9-.7-3.8t-.5-3.9c-.7-6.3-.7-12.8.3-19.1c1.1-6.2,3-12.3,6-18c.8-1.5,1.6-2.6,2.3-3.3.7-.8,1.4-1.2,2.1-1.3c1-.3,2.2-.2,3.5,0c1.4.1,3,.4,5.1.4c1.1.1,5.9-.4,10.4-1.3s8.8-2.1,8.9-3.4c-.5,4.9-1.4,9.7-2.2,14.6s-1.6,9.7-1.8,14.6c-.5,9.6,1.1,19.1,2.9,28.5c1.7,9.5,3.6,19,3.7,28.5Z",
    fill: "url(#eCwuQE5mxSB29-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2191.2,1090.5c-1.1,4.6-2.7,9.1-4.9,13.4s-5,8.2-8.3,11.7c-3.3-5.1-6.2-10.8-8.3-16.7-2.2-6-3.7-12.2-4.3-18.6c1.9-.2,3.8-.1,5.8.2c1.9.3,3.9.9,5.7,1.5q2,.7,3.9,1.6q1.8.9,3.6,2c1.1.6,1.8,1.1,2.5,1.6s1.4,1,2.6,1.9l.8.7.9.7Z",
    fill: "url(#eCwuQE5mxSB30-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2246.2,918.1q.1-.2.1-.3.1-.2.1-.3.6-1.5,1.4-3q.7-1.4,1.5-2.8.7-1.4,1.5-2.7t1.7-2.5q1.9-2.6,4.3-4.6q2.3-2,5.2-3.3c4.3-1.8,8.3-1,11.5,1.2c3.3,2.2,5.8,5.8,7.2,9.7c2.5,7.1.5,16.7-4.3,24-4.8,7.4-12.3,12.4-21,10.6q-1.7-.4-3.2-1.3-1.5-.8-2.6-2.1c-1.3-1.4-2.3-3-3-4.7-.8-1.8-1.3-3.6-1.6-5.4-.4-2.1-.4-4.2-.2-6.3s.7-4.2,1.4-6.2Z",
    fill: "url(#eCwuQE5mxSB31-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2196.6,1047.3c.6-2.6,1.5-5.2,2.6-7.6s2.6-4.6,4.5-6.5c.4-.4.8-.9,1.3-1.2s1-.6,1.6-.7c.8-.1,1.5,0,2.2.2.7.3,1.4.7,2,1.1c2.7,1.9,4.9,4.4,6.5,7.2c1.7,2.9,2.7,6.1,3.3,9.4.6,3.2.7,6.5.6,9.8s-.5,6.6-1,9.9q-.8,5.3-1.7,10.6-1,5.3-2.3,10.6c-.3,1.7-.7,3.4-1.1,5.1s-.9,3.3-1.7,4.8-1.7,2.8-2.5,4.1c-.9,1.2-1.7,2.5-2.3,4.1-.2.7-.4,1.5-.5,2.2-.2.6-.3,1.1-.5,1.1-.2-1.3-.9-3.8-1.8-6.3-.8-2.5-1.7-5-2.2-6.2-1.4-3.4-2.2-5.6-2.8-7.7s-1.1-4-1.9-7c-1.7-6-2.9-12.2-3.5-18.4-.5-6.2-.2-12.4,1.2-18.6Z",
    fill: "url(#eCwuQE5mxSB32-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2290.9,1030.4q-.5-.5-1-1.1-.5-.5-1-1.1c-4.9-5.8-8.8-11.4-12-17.1-3.2-5.6-5.7-11.2-7.8-16.9q-.1-.2-.2-.4t-.2-.3q-1.1-3-2.1-6-1-3.1-1.9-6.2-2-6.3-3.7-12.6t-3.2-12.7q-.4-1.8-.8-3.5-.4-1.8-.8-3.6-1.2-4.9-2.3-9.9-1-4.9-2.1-9.9-.2-1.1-.5-2.2-.2-1.1-.4-2.2c-1-4.8-2-9.7-3-14.5-.9-4.9-1.8-9.8-2.6-14.7-.7-4.8-1.3-9.7-1.9-14.5-.7-4.8-1.4-9.6-2.7-14.4l-.2-.8-.3-.8c-.7-2.6-1.7-4.3-3-5.8-1.4-1.4-3.1-2.6-5.5-4q-.8-.6-1.7-1-.9-.5-1.8-.9-2.3-1.1-4.6-1.8-2.4-.8-4.8-1.4-1.7-.3-3.3-.5-1.7-.2-3.3-.3-.9-.1-1.7-.1t-1.6,0q-.6,0-1.2,0-.7,0-1.3,0-.9,0-2,.1-1,.1-2.2.3c-5,.7-10.2,1.2-15.3,1.9s-10.1,1.6-15.1,3.1q-9.7,2.9-19.3,6.1-9.7,3.1-19.2,6.5-1.8.6-3.7,1.2-2,.6-4.1,1.3-.7.2-1.4.4-.7.3-1.4.5-.6.2-1.2.4-.6.3-1.1.5t-1,.4-1,.4q-1,.5-1.8,1-.9.5-1.8,1c-1.4.9-2.6,1.9-3.6,3.1-1.1,1.2-1.9,2.5-2.4,4q-.4,1.1-.7,2.1t-.6,2.1c-1.5,5.8-2.2,12.1-2.3,18.3-.1,6.3.5,12.4,1.5,18q.7,3.7,2,7.1q1.3,3.5,3,6.8c1.4,2.9,3,5.7,4.7,8.5c1.6,2.8,3.2,5.6,4.7,8.6q.9,1.8,1.8,3.8.8,2.1,1.5,4.3c1.2,4,2,8.1,2.5,12.3.6,4.1,1,8.3,1.3,12.3.4,5.7,2.3,10.6,5,15s6.3,8.4,10,12.5q4.3,4.7,9,9.2q4.7,4.4,9.8,8.3q2.5,2,5.1,3.9q2.7,1.9,5.4,3.6c1.4.9,2.6,2,4,3c1.3.9,2.7,1.8,4.4,2.3q.9.2,1.9.4.9.1,2,.2c.7,0,1.4,0,2.2-.1.7-.1,1.5-.3,2.1-.3q.1,0,.2,0t.2,0l.7-.1.7-.1q1.7-.2,3.3-.6q1.7-.3,3.3-.8c1-.3,2.6-.7,4-1.1c1.3-.3,2.4-.6,2.4-.6l.2.5.3.6q.3.4.4.9.1.4.2.7.6,1.9,1.2,3.8.5,1.9,1,3.8.6,2.3,1,4.6t.8,4.6q.1.9.3,1.9.1,1,.2,2c.8,6.7,1.1,13.3,1.1,20c0,6.6-.2,13.3-.5,20q2.6-4.6,5.7-8.8q3.2-4.1,6.9-7.8c1.1-1.2,2.5-2.4,4.1-3.3c1.5-.9,3.2-1.4,4.9-1.4c2.5.1,4.7,1,6.4,2.6s3,3.7,3.5,6.1q.2.6.3,1.2q0,.7.1,1.3q1.5-.1,2.9-.2q1.4-.2,2.7-.4q2-.2,3.8-.5q1.9-.4,3.7-.7c5.4-2.7,10.9-5.4,16-8.5c5-3.2,9.6-6.9,13-11.8c2.1-3,3.9-6.3,5.4-9.7s2.8-6.9,3.9-10.4c.7-2.4,1.4-5,2-7.6.5-2.6.9-5.3,1.1-7.9q-1.3-1.2-2.7-2.5-1.4-1.4-2.9-3Z",
    fill: "url(#eCwuQE5mxSB33-fill)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2151,991.7c.5.7,1.4,1.4,2.3,2.1.9.6,1.9,1.2,2.6,1.4.6.3,1.4.5,2.1.6s1.3.2,1.6.1c.2,0,0-.1-.4-.1-.3-.1-.8-.1-1-.3-.3-.1-.8-.3-1.3-.5-.6-.3-1.1-.5-1.5-.8q-.7-.3-1.3-.8-.7-.4-1.4-1c-.4-.4-.9-1-1.3-1.6-.5-.6-.8-1.3-.9-1.8c0-.5-.1-.8-.1-1s.1-.4.2-.9c.2-.5.4-.9.7-1.3s.6-.8.8-1.3c.3-.5.5-.7.6-1c.2-.4.4-.7.7-1.5s.7-1.9,1-3.1c.4-1.2.6-2.5.8-3.6q.2-1.5.3-3.2t.1-3.4c.1-3.3.5-9-1.6-17.1s-6.6-18.7-16.2-31.9c1.1,2.8,5.4,7.9,9.3,15.5c3.9,7.7,7.6,17.8,7.5,30.6-.1,1.3-.1,2.8-.1,4.2c0,1.5-.1,2.9-.2,4.3-.1,1.3-.5,3.1-.9,4.7-.5,1.7-1,3.3-1.4,4.2-.5,1-.7,1.4-1,1.6-.2.3-.4.5-.7,1-.2.6-.4.8-.5,1-.1.3-.1.5-.2,1.1q0,1,.4,1.9.3,1,1,1.9Z",
    fill: "url(#eCwuQE5mxSB35-fill)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M2290.7,1030.8q-.6-.5-1.1-1-.4-.6-.9-1.2c-5-5.8-8.8-11.4-12-17s-5.7-11.2-7.9-17q-.1-.1-.2-.3t-.1-.4q-1.2-3-2.2-6-1.1-3.1-2.1-6.2c-2.6-8.7-4.9-17.4-7-26.1s-4-17.4-5.8-26.1q-.3-1.1-.5-2.2-.2-1-.4-2.2c-1-4.8-2-9.7-3-14.5-1-4.9-1.9-9.8-2.6-14.7-.8-4.8-1.3-9.7-1.9-14.5-.7-4.8-1.5-9.6-2.7-14.4l-.3-.8-.2-.8c-.8-2.6-1.7-4.3-3.1-5.8-1.3-1.4-3.1-2.6-5.4-4q-.8-.5-1.7-1-.8-.5-1.7-.9-2.2-1-4.6-1.8t-4.8-1.3q-1.6-.3-3.3-.5-1.7-.3-3.3-.4-.8,0-1.6,0-.9-.1-1.7-.1-.6,0-1.2,0-.6.1-1.2.1-1,0-2,.1-1.1.1-2.2.2-.1,0-.1,0t-.1,0c-5.1.7-10.2,1.2-15.3,1.9-5.1.8-10.2,1.7-15.1,3.1q-9.7,2.9-19.4,6.1-9.6,3.1-19.2,6.5-1.6.6-3.5,1.2-2,.6-4.1,1.3-.6.2-1.3.5-.8.2-1.5.5-.6.1-1.2.4-.5.2-1.1.4-.5.2-1,.4t-1,.5q-.9.5-1.8.9-.9.5-1.8,1c-1.4.9-2.6,2-3.6,3.1-1,1.2-1.8,2.5-2.4,4.1q-.3,1-.6,2-.4,1.1-.6,2.1c1.3.5,2.9.8,4.4,1c1.5.3,2.8.4,3.6.6c2.6.5,5.3.9,8,1c2.7.2,5.4.3,8.1.3c4.8,0,9.7-.3,14.6-.9c4.9-.5,9.7-1.3,14.4-2.3c4.7-.9,9.2-2.1,13.7-3.4c4.5-1.4,9-2.8,13.5-4.2c1.7-.5,3.8-1.3,6-1.8c2.1-.6,4.3-1,6-.8c2.5.3,4.3,1.6,5.9,3.2c1.6,1.7,2.9,3.7,4.3,5.5c3.1,4,5.4,8.5,7.3,13.2c2,4.6,3.6,9.5,5.3,14.2c1.9,5.3,3.7,10.6,5.3,16c1.5,5.4,2.8,10.8,3.7,16.3c2.1,12.1,3.6,24.2,2.9,35.9-.7,11.8-3.6,23.3-10.3,34.3q-1.3,2.1-2.8,4.1-1.4,2-3,3.8c-3.2,3.9-6.9,7.4-10.9,10.5s-8.2,5.9-12.7,8.3c-1.5.8-3.9,1.6-6,2.2s-3.8,1-3.8,1c.4,0,.9.1,1.6.1.6.1,1.4.1,2.4-.1q.2,0,.2,0q.1,0,.2,0l.8-.1.7-.1q1.6-.2,3.3-.6q1.6-.3,3.2-.7c1.1-.3,2.7-.8,4-1.1c1.4-.4,2.4-.7,2.4-.7l.3.4.3.4c.3-.1.6-.2.8-.3.3,0,.5-.1.8-.1q.8,0,1.7.1.8,0,1.6,0c.2,0,.7,0,1.1,0s.8.1.9.4c.5,1.2,2.9,1.2,5.3,1.2c2.5,0,4.9,0,5.3,1.2.3,1.6,2.8.8,5.3.1c2.4-.8,4.8-1.5,5,0c6.3.6,9.5,1.4,12.7,1.7c3.3.3,6.4,0,12.7-1.4c8.9-2.2,14.3-2.5,19-3.8s8.5-3.6,14.3-9.8Z",
    fill: "url(#eCwuQE5mxSB36-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2177.5,922.2q.1.7.2,1.4q0,.7.1,1.4c.3,3.1.7,6.5,1.4,9.7.7,3.3,1.7,6.5,3.3,9.2.5.9,1,1.7,1.5,2.5.6.7,1.2,1.4,2.1,2.1c1.6,1.1,3.5,1.5,5.5,1.6c1.9.1,3.9,0,5.9.2q1.8.2,3.6.3t3.6,0c6.5-.5,11.9-4.2,15.7-9.2c3.9-4.9,6.1-11.1,6-16.7c0-2.7-.3-6.1-1.2-9.3-.9-3.1-2.4-6-4.9-7.6-3.9-2.4-7.8-3.2-11.8-3.6s-8.2-.4-12.4-1.2c-2.3-.4-4.6-1.1-6.9-1.7-2.2-.5-4.5-1-6.8-.7q-.5.1-.9.2-.5.1-.8.4t-.5.7-.3.8q-1.5,4.7-2.1,9.6-.6,5-.3,9.9Z",
    fill: "url(#eCwuQE5mxSB37-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2183.5,946.1c.5,1.5,1.5,2.4,2.7,3.1s2.7,1.1,4,1.6q.1,0,.2,0q.1.1.2.1c0,0,.2,0,.4.1.2,0,.5.1.8.1c1.5.2,2.8.3,4.1.3s2.5-.2,4-.4q.2-.1.5-.2.3,0,.6-.1q1.2-.3,2.5-.7q1.3-.3,2.6-.7q1.1-.3,2-.7q1-.5,1.9-.9q1.8-1,3.2-2.5q1.3-1.5,2.1-3.4q0,0,0,0t0,0c1-2.1,1.5-4.5,1.7-6.8.2-2.4.1-4.8-.1-7q-.1-.5-.2-1-.1-.4-.2-.9c-.3-1.2-.8-2.4-1.5-3.3s-1.7-1.6-3.2-1.8c-1.7-.3-3.4-.2-5.1,0s-3.4.6-5,1.1c-3.9,1-7.8,2.3-11,4.5-3.2,2.1-5.7,5.1-6.8,9.3q-.3,1.4-.6,3-.3,1.5-.3,2.9q0,.9,0,1.7.1.8.3,1.6q0,.2.1.5q0,.2.1.5Z",
    fill: "#b74e39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2110.9,936.4c.6.9,1.2,1.8,1.8,2.6.5.8,1.1,1.6,1.4,2.3c1.2,2,2.3,4,3.5,6c1.1,1.9,2.2,3.9,3.2,6c.7,1.2,1.3,2.6,1.9,3.9.6,1.4,1.2,2.7,2,3.9c0,0,.3-.1.7-.3.3-.2.6-.3.7-.3c0,.1.1.3.2.5s.2.5.2.5c2.3,1.8,4.3,3.3,6.4,4.3c2.2.9,4.5,1.2,7.4.6c4.7-1,7.4-4.1,8.8-8.1c1.4-3.9,1.5-8.6.9-12.6-.4-2.7-1.2-5.3-2.1-7.8-.9-2.6-2-5-3.2-7.5-1.2-2.6-2.6-5.2-4.1-7.6-1.6-2.5-3.4-4.8-5.5-6.8-1.4-1.3-2.4-2.1-3.3-2.1s-1.8.6-3.2,2c-1.1,1.1-2.1,2.1-3.3,3.1-1.2.9-2.4,1.7-3.8,2.3-1.9.9-3.7,1.6-5.4,2.5s-3.3,2-4.7,3.6c-.5.5-.9,1-1.3,1.6-.4.5-.7,1.2-.8,1.8-.2.9,0,1.8.3,2.8.3.9.8,1.9,1.3,2.8Z",
    fill: "url(#eCwuQE5mxSB39-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2122,954.5q.1.6.3,1.1.2.6.4,1.2.2.4.3.7.2.4.4.8.5,1.4,1.2,2.8t1.6,2.5q.1.1.3.2.1.2.2.2c.9,1.1,1.9,1.7,3,2.1c1.2.4,2.4.5,3.7.7q.3,0,.5,0q.2.1.5.1.7.1,1.5.2.7,0,1.6,0c1.9,0,4-.2,5.9-.8c1.8-.6,3.5-1.6,4.5-3.1q.4-.5.7-1.2.3-.6.4-1.4q0-.1,0-.3q0-.1.1-.2.1-1.6-.2-3.1-.4-1.6-1.2-3.1c-.6-1.4-1.6-2.7-2.6-3.8-1-1.2-2.1-2.2-3.2-3.1-2.3-1.9-5.2-2.9-8.3-3.2-3-.4-6.2-.1-9,.6-.9.3-1.9.6-2.6,1.2-.8.5-1.2,1.3-1.2,2.5q0,.9.1,1.7t.3,1.6.3,1.6q.2.8.5,1.5Z",
    fill: "#b74e39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2169.4,982.9c-1,.8-2.2,1.5-3.4,2.2-1.2.6-2.5,1.2-3.8,1.5q-1.8.5-3.7.9-1.8.4-3.7.5-.9.1-1.8,0-.9,0-1.8-.1c-.3,0-.5-.1-.7-.1-.2.1-.2.2-.2.7q0,.2.1.5t.2.6q-.2-.3-.3-.6-.1-.4-.2-.8c0-.6.1-1.3.3-1.9.3-.5.6-.9.9-.8c1.2.1,2.4.2,3.4.1c1,0,1.9-.1,2.4-.1c1.7-.2,3.4-.5,5-.9s3.2-1,4.8-1.7q1.1-.5,2.1-1q1.1-.6,2.1-1.1c.4-.3.8-.4,1.3-.7s1.1-.8,2-1.8q-.4.6-.9,1.1-.5.6-.9,1-.8.7-1.5,1.3-.8.6-1.7,1.2Z",
    fill: "#ffe5d7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2150.3,988.5c0-.5,0-.6.2-.7.2,0,.4.1.7.1q.9.1,1.8.1.9.1,1.8,0q1.9-.1,3.7-.5q1.9-.4,3.7-.9c1.3-.3,2.6-.9,3.8-1.5c1.2-.7,2.4-1.4,3.4-2.2q.9-.6,1.7-1.2.7-.6,1.5-1.3.4-.4.9-1q.5-.5.9-1.1.1-.2.2-.4.2-.2.2-.5.7.2,1.2.4.6.2,1,.3c.9.3,1.8.6,2.7.8.9.3,1.8.6,2.6,1.1.7.4,1.1.8,1.4,1.4.2.5.3,1.2.3,1.9q-.1.5-.1,1.1-.1.5-.1,1.1c0,.4,0,.8-.1,1.1-.1.4-.3.7-.7.9q-.2.2-.4.3-.3,0-.5.1-.5.1-.9.1-.5.1-.9.1-.4.1-.8.2-.4,0-.8.1c-1.5.2-2.8.8-4.1,1.4-1.3.7-2.5,1.5-3.7,2.3-1.1.7-2.3,1.3-3.6,1.8-1.2.6-2.5,1.1-3.7,1.5-1.3.4-2.5.7-3.8.7s-2.5-.2-3.8-.8c-1.1-.5-2.2-1.2-3.1-2.1-1-.9-1.7-2-2.1-3.2q-.1-.1-.1-.2t-.1-.2q-.1-.3-.2-.6t-.1-.5Z",
    fill: "url(#eCwuQE5mxSB42-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2293.3,1051.1c1.5-.1,2.1-3.9,2.1-7.7.1-3.9-.3-7.9-.6-8.5-1.2-2.3-2.6-4.5-3.9-6.8-1.3-2.2-2.4-4.6-3.2-7.4-.5-1.6-.9-3.4-1.4-5.1-.5-1.6-1-3.3-1.9-4.8-.6-1.3-1.5-2.4-2.4-3.5-.8-1.1-1.8-2.1-2.7-3.2-5.9-6.9-10.2-14.5-13.6-22.6-3.3-8.1-5.8-16.6-7.8-25.2-.3-1.2-.6-2.3-.8-3.3s-.4-2.1-.7-3.3c-.6-2.9-1.4-6.2-2.2-9.6s-1.7-6.9-2.3-10.2q-.1-.1-.2-.1q0-.1-.1-.2c-1-1.1-2-2.2-3.1-3.2-1-1-2.1-2-3.1-2.6c0,4.6.3,9.3.8,13.8.5,4.6,1.2,9.2,1.9,13.7.7,4.3,1.2,8.5,1.7,12.8s1,8.5,1.6,12.7c.5,3.3,1,6.7.9,10s-.8,6.6-2.4,9.6c-.7,1.2-1.5,2.4-2.3,3.6-.9,1.2-1.8,2.3-2.7,3.5-2.5,3.1-5.1,6.2-7.7,9.2s-5.3,6-8.2,8.8c-1.9,1.9-3.8,3.8-5.9,5.6-2,1.8-4.1,3.6-6.2,5.2q-1.6,1.3-3.3,2.5-1.8,1.2-3.6,2.3c-.7.5-1.7,1-2.9,1.7-1.1.6-2.3,1.2-3.5,1.9c0,0,.3.7.5,1.3.3.6.5,1.3.5,1.2s.7.2,1.5.6c.9.3,1.7.7,2,.8q1.6.6,3.2,1q1.6.5,3.3.9q3.2.8,6.4,1.5q3.3.7,6.6,1.3q6.5,1.1,13.1,1.7q6.5.6,13.1.8c6.5.3,13.1.4,19.7.3s13.2-.4,19.8-1Z",
    fill: "url(#eCwuQE5mxSB43-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2097.6,868.8c1.7-1.7,3.6-3.1,5.5-4.5c2-1.3,4-2.5,6.1-3.7c2.4-1.4,4.8-2.3,7.3-3c2.4-.8,4.9-1.4,7.5-2.1-4.7-2.6-10.1-4.8-15.6-6.2s-11.2-2.1-16.7-1.9c.1-2.8,1.9-6,4.3-8.9c2.3-3,5.1-5.6,7-7.4c6-5.3,12.7-9.6,19.8-12.8c7.2-3.2,14.8-5.4,22.8-6.7c4.5-.6,8.9-1,13.2-1c4.4,0,8.8.4,13.3,1c2.6.4,5.2.9,7.7,1.6c2.6.6,5.2,1.3,7.7,1.8c2.4.6,4.6,1.4,6.8,2.3c2.3.8,4.5,1.7,6.8,2.3.9-2.6,2.9-5,5.3-7s5.2-3.7,7.7-4.7c2-.8,4.2-1.4,6.4-1.7c2.1-.4,4.4-.5,6.6-.5c1.4,0,3.8,0,6.1.4c2.3.3,4.4,1,5.3,2.5-5,.6-9.8,2.7-13.3,6-3.6,3.2-6,7.7-6.4,12.9c3.5-1.3,7.1-2,10.9-2.2c3.7-.2,7.5.1,11.1.8q2.2.4,4.3,1q2.2.7,4.3,1.6c1.1.5,2.5,1.1,3.8,1.8c1.3.8,2.5,1.7,3.2,2.8-3,.1-5.5,1.6-7.4,3.7-1.9,2.2-3.3,5-4.1,7.7-.6,2.5-.9,5-.9,7.5c0,2.6.1,5.1.3,7.7s.2,5.3.3,8c0,2.7.1,5.3.3,8q.6,7.1,1.3,14.2.8,7.1,1.7,14.2.6,5.1,1.3,10.2.7,5,1.7,10.1c.4,1.7.8,3.3,1.1,4.8.4,1.6.7,3.2,1,4.9.3,1.9.8,3.7,1.2,5.5.5,1.9.9,3.7,1.2,5.6c0,.1-.3.2-.8.3-.6.2-1.3.3-2,.3-1.2.1-1.9.2-2.7.2-.7-.1-1.4-.1-2.6-.2c0,0-.3-1.6-.6-3.6-.3-2.1-.7-4.5-1-6.2-.2-1.3-.4-2.7-.6-4.1s-.4-2.8-.7-4.2q-.1-.8-.3-1.6-.1-.8-.3-1.6-.1-.7-.3-1.4-.1-.8-.3-1.5c-1.4-7-3.1-13.9-5-20.7q-2.8-10.2-6.3-20.3-.6-1.5-1.1-2.9-.6-1.5-1.3-2.9-.1-.2-.3-.4-.1-.2-.3-.3-.1-.1-.3-.2-.2,0-.4-.1-1.1-.2-2.3-.3-1.1-.2-2.3-.2c-.4,0-1.2,0-2,0s-1.6-.1-1.9-.4q-.1-.1-.2-.2q0-.1-.1-.2c-.5-1.3-.9-2.7-1.3-4.1-.3-1.3-.7-2.7-1-4.1q-.3-1.2-.7-2.4-.3-1.2-.6-2.3-.2-.8-.4-1.5-.1-.8-.3-1.5q0-.2-.1-.3q0-.2-.1-.4-.2-.6-.3-1.2-.2-.6-.4-1.1c-2.8,2.1-6.1,4-9.5,5.7-3.4,1.6-7,3-10.3,4.3-7.5,2.7-14.9,6-22.3,9-7.5,3-15.1,5.6-23.1,7.1q-5.9,1.1-11.8,1.8t-11.9,1.2c-3.6.2-7.2,0-10.7-.3-3.6-.3-7.1-.8-10.7-1-3.2.5-6.7,2.8-9.9,5.5s-6.1,5.8-8,8c.6-4.9,1.7-9.7,3.5-14.2s4.4-8.6,8.1-12.1Z",
    fill: "#010019"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2127.9,909.1c-.4,1.4-.9,2.6-1.7,3.7-.8,1-1.7,2-2.9,3s-2.6,1.7-3.9,2.5c-1.4.8-2.9,1.5-4.3,2.5s-2.9,1.9-4.3,3-2.6,2.5-3.2,4.4c-.5,1.2-.5,2.5-.3,3.8.2,1.2.7,2.4,1.4,3.5.3.3.9,1.1,1.5,1.6.7.6,1.4,1.1,1.8,1c.2-.1.4-.4.7-.9.2-.5.6-1.1,1.2-1.9c1.5-1.9,3.1-3.5,4.8-4.9s3.5-2.6,5.4-3.7s4.2-2.6,6.3-4.4c2-1.7,3.8-3.8,4.7-6c.9-2,.2-4-1.2-5.3-1.4-1.4-3.5-2.2-5.4-2-.1,0-.2,0-.4,0-.1,0-.2.1-.2.1Z",
    fill: "url(#eCwuQE5mxSB46-fill)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M2176.3,893.7c.2.4,1,.9,1.9,1.3s1.7.7,1.9.7c1,.3,2.4.6,3.9.8c1.5.3,3,.5,4,.5c1.9.1,3.5.2,5,.2c1.5.1,2.8.2,4.2.4q3.3.5,6.6,1t6.6,1.1c2.2.5,4.5.9,6.6,1.6s4,1.7,5.6,3.4q.1.1.1.2.1.1.2.1q1.3,1.6,2.2,3.3q1,1.8,1.5,3.8c.2.9.5,2.4.6,3.8c0,1.5-.2,2.9-.9,3.7.1-.1-.4-.8-1-1.5s-1.2-1.4-1.3-1.5q-.9-.8-1.9-1.5t-2.1-1.2q-1.7-.9-3.6-1.5-1.8-.6-3.7-1.1c-4-1.1-7.9-1.8-12-2.3-4-.5-8-.8-12.1-1.3-1.4-.2-3-.3-4.5-.5s-2.9-.5-3.8-.8c-1-.3-1.7-.7-2.4-1.2s-1.3-1.1-1.9-2q-.6-.7-.8-1.6t-.2-1.8c0-1,0-2.1.2-3.2.1-1.1.5-2.1,1.1-2.9Z",
    fill: "url(#eCwuQE5mxSB47-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2260.2,937.1c.9.1,2-.3,3-.8s2-1.1,2.7-1.6q1.3-.9,2.4-2q1-1.2,1.8-2.5c.9-1.5,1.6-3.3,1.9-5.2.3-2,.3-4-.2-5.8q-.3-1.3-1-2.4-.6-1.1-1.6-2c-.8-.7-1.9-1.2-3.1-1.6s-2.4-.6-3.4-.6c-2.2.1-4,.7-5.5,1.7-1.5,1.1-2.7,2.6-3.7,4.4q-.3.7-.6,1.4-.3.6-.5,1.3-.3.9-.6,1.9-.2.9-.4,1.8c.5-1.1,1.2-2.2,2.1-3.1s2-1.6,3.1-1.8q.9-.2,1.9,0q.9.1,1.8.7c1.8,1,2.8,2.8,3.2,4.8.4,1.9.3,4.1-.2,5.8-.3,1.2-.7,2.2-1.2,3-.5.9-1.2,1.7-1.9,2.6Z",
    fill: "#910f2e"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2179.3,978.7q.6.1,1.1.3.5.1,1,.2.4.2.8.3.4.2.8.4c.7.3,1,.8,1.2,1.4.3.6.3,1.3.3,1.9q0,1.1-.3,2.1-.2.9-.7,1.9c0,0,.1-.6.2-1.4.1-.7.1-1.7.1-2.3c0-.4,0-.9-.1-1.3-.1-.5-.3-1-.5-1.2q-.3-.3-.7-.5t-.8-.3q-.9-.3-1.9-.6-.9-.4-1.9-.6-.5-.2-.9-.3-.5-.2-.9-.4c-.2-.1-.7-.3-1-.5-.3-.3-.5-.4-.3-.4q1.1.4,2.2.7t2.3.6Z",
    fill: "#cc5e48"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M2168.2,990.8c-.1-.3,0-.6.3-1c.2-.3.5-.6.7-.8q.4-.5,1-1q.5-.4,1.1-.8c.8-.6,1.5-1.2,2.4-1.7.8-.4,1.7-.8,2.7-.8.4,0,.8,0,1,.2s.3.6.2,1-.4.7-.6,1c-.3.2-.6.4-1,.6q-.8.6-1.8.9-1,.4-2,.7t-2,.7-2,1Z",
    fill: "#b74e39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2217.4,934q0,.9-.1,1.8t-.3,1.8q0,.5-.1,1.1-.1.5-.3,1q0,.4-.1.7t-.2.6q-.4,1.7-1.2,3.2t-1.9,2.7q-.7.6-1.3,1.1-.7.5-1.4.9-1,.5-1.9.9-1,.4-2.1.7h-.2l-.2.1q-.2.1-.4.1-.3.1-.5.1-1,.3-1.9.6-1,.2-1.9.5-.3.1-.6.1-.3.1-.5.1c-1.4.3-2.7.4-4,.5-1.3,0-2.6-.1-4.1-.3q-.5-.1-.8-.1-.3-.1-.3-.1-.1,0-.2-.1-.2,0-.2,0c-1.2-.4-2.4-.8-3.4-1.2-1-.5-1.9-1.1-2.6-2.1q-.2-.3-.4-.6-.2-.4-.4-.8v-.2l-.1-.3q-.1-.1-.1-.2q0-.2,0-.3-.2-.8-.2-1.6-.1-.8,0-1.6.1-2.2.9-4.1t2.1-3.7q1.2-1.5,2.6-2.8q1.5-1.2,3.1-2.3c2.7-1.9,5.8-3.4,8.9-4.3c3.2-1,6.5-1.5,9.8-1.3q.9,0,1.8.1.9.2,1.7.5q1.3.6,2,1.6t.9,2.5q.2,1.1.2,2.3.1,1.2-.1,2.4Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2217.4,934.1q0,.9-.1,1.8t-.3,1.8q0,.5-.1,1.1-.1.5-.3,1-2.7.2-5.5.5-2.8.4-5.6,1c-1.2-2.4-3.2-4.1-5.6-5.1s-5.2-1.2-7.9-.3c-2.4.7-4.4,2.2-5.8,4-1.5,1.9-2.4,4.2-2.5,6.5c0-.6-.1-1.2-.2-1.9-.1-.6-.2-1.2-.1-1.9q.2-.9.5-1.9.2-.9.6-1.8.7-1.8,1.9-3.4q1.1-1.6,2.5-2.9c1.5-1.5,3.2-2.8,5.1-3.8c1.8-1.1,3.8-2,5.8-2.7c1.9-.7,4-1.3,6-1.6c2.1-.3,4.2-.3,6.2.2c1.2.3,2.5.8,3.4,1.5c1,.8,1.7,1.8,1.9,3.1q.2,1.1.2,2.3.1,1.3-.1,2.5Z",
    fill: "#c4c4c4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2205.9,941.3c-1.1.1-2.2.3-3.3.6-1.1.2-2.2.5-3.3.8q-2.4.7-4.9,1.7-2.4.9-4.7,2-.8.4-1.6.7t-1.6.7q-.2.1-.5.2-.2.1-.5.2-.1.1-.2.1-.2.1-.3.2c0,0-.1,0-.2.1-.1,0-.2.1-.2.1q-.2-.3-.3-.6-.2-.3-.3-.6-.1-.2-.2-.5t-.1-.6c.1-2.3,1-4.6,2.5-6.5c1.4-1.8,3.4-3.3,5.8-4c2.7-.9,5.6-.7,8.1.3c2.5.9,4.6,2.7,5.8,5.1Z",
    fill: "#606060"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2205.8,950.8c-.8.2-1.5.4-2.2.6s-1.4.4-2.2.5l-1.1.3-1,.2c-1.4.3-2.5.4-3.6.4-1.1-.1-2.2-.2-3.7-.5q-.5,0-.9-.1t-.7-.2l-.4-.1-.5-.2c-1.1-.3-2.1-.6-2.9-1-.9-.4-1.5-.9-2-2h.1v-.1c.8-.5,1.6-.9,2.5-1.3.9-.3,1.8-.6,2.5-1q2.3-1,4.7-2q2.5-.9,4.9-1.6q1.6-.5,3.1-.8q1.6-.4,3.1-.6.3.5.5.9.2.5.4,1c.4,1.2.5,2.5.4,3.8s-.5,2.6-1,3.8Z",
    fill: "#bababa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2206.1,942.9q.5,1.7.4,3.5t-.8,3.5q-.1.3-.2.6-.1.2-.3.5.3-.1.5-.2t.4-.2q.1-.1.1-.2.1-.1.1-.2.8-1.8.9-3.7t-.5-3.8c-1-3.1-3-5.4-5.6-6.8-2.6-1.3-5.8-1.8-8.9-.9q.1.1.1.3.1.2.1.3c2.9-.8,5.9-.4,8.4.9c2.4,1.3,4.4,3.5,5.3,6.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2188.3,948.7q.3,1,.9,1.9t1.5,1.5c0,.1.3.1.6.2.3,0,.6.1,1,.2c1.4.2,2.7.3,4.1.3c1.3,0,2.6-.2,4.1-.6c1.3-.9,2.2-2.2,2.6-3.6.5-1.4.5-3,0-4.5-.6-2-2-3.6-3.7-4.4-1.7-.9-3.8-1.1-5.9-.5-2,.6-3.7,2-4.6,3.7-1,1.7-1.2,3.8-.6,5.8Z",
    fill: "#020102"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2183.4,943.1c-.1,1.3,0,2.2.1,2.7.1.6.2.8.2.8c0-.3.2-.6.4-.8.2-.3.5-.6.6-.8q.5-.6.9-1.2t.9-1.1q1.3-1.4,2.9-2.5q1.7-1,3.4-1.8q1.8-.7,3.7-1.2t3.7-.9c3-.6,6-1.2,9-1.9c2.9-.8,5.9-1.6,8.7-2.7c0-1.7-.3-3.8-1.1-5.5-.9-1.8-2.2-3.1-4.2-3.4-1.8-.2-3.5-.2-5.2.1-1.7.2-3.3.6-5,1.1-4,1-7.9,2.3-11.1,4.4-3.3,2.1-5.8,5-7,9-.2,1-.4,1.9-.6,2.9-.2.9-.4,1.9-.3,2.8Z",
    fill: "url(#eCwuQE5mxSB58-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2183.7,946.6c0,0,.1-.1.3-.3.2-.1.4-.3.6-.5.3-.3.7-.6,1.1-1c.5-.4.9-.7,1.1-1c.6-.5.9-.8,1.3-1.2.4-.3.8-.6,1.4-1q1.9-1.1,4-1.9t4.2-1.4q1.6-.4,3.1-.8q1.6-.3,3.1-.5q1.8-.2,3.6-.4t3.6-.4q1.7-.2,3.4-.5q1.8-.3,3.4-.8c1.4-.5,2-1.3,2.4-2.3.3-1,.4-2.2.7-3.3-.3.4-.8.6-1.4.8-.5.2-1.1.3-1.5.4q-1.1.3-2.2.5t-2.2.4q-2.9.5-5.7,1.1-2.9.5-5.7,1.2c-2.7.7-5.6,1.6-8.3,2.8-2.8,1.3-5.3,2.9-7.2,5.2q-.7.7-1.3,1.5t-1,1.7c-.2.4-.4.7-.6,1.1-.1.3-.2.5-.2.6Z",
    fill: "#020102"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2183.7,1008.4c0,0,.5-.7,1.5-1.9.9-1.1,2.4-2.7,4.3-4.3.8-.6,1.5-1.2,2.2-1.7.8-.6,1.6-1.1,2.5-1.6.7-.4,2.2-1.1,3.9-1.7c1.7-.7,3.4-1.4,4.4-1.7-.3.1-1,.2-1.8.4-.9.1-2,.4-3.1.7s-2.3.7-3.4,1.2c-1.2.5-2.2,1-3.1,1.6-.9.5-2.3,1.4-3.7,2.9-1.3,1.4-2.7,3.4-3.7,6.1Z",
    fill: "url(#eCwuQE5mxSB60-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2200.3,941.9c-.1.4,0,.8.3,1.1.2.3.5.6,1,.6.4.1.8,0,1.1-.2.4-.3.6-.6.7-1c0-.5-.1-.9-.3-1.2s-.6-.6-1-.6c-.5-.1-.9,0-1.2.2-.3.3-.5.6-.6,1.1Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2122.4,956q.1.2.2.5.1.2.2.4.3.8.6,1.6.3.7.7,1.5l.1.2.1.3.1.1.1.2c0,0,.1.3.3.7.2.3.4.8.5,1q.3.4.4.8.2.3.4.7.4.7,1,1.4.5.6,1.2,1.1c.8.7,1.7,1,2.6,1.3c1,.3,2,.4,3,.5q.2,0,.5,0q.2.1.4.1.3,0,.5.1.2,0,.5,0q.5.1,1,.1.6,0,1.2,0q.1,0,.2,0q0,0,.2,0q.3,0,.7,0q.5-.1.9-.1.5-.1,1.1-.1.5-.1.9-.2.3,0,.5-.1.2,0,.4-.1q1.7-.4,3-1.1q1.3-.8,2.1-1.8c.3-.4.5-.8.8-1.1.2-.4.3-.8.5-1.3q.1-.2.1-.5.1-.4.1-.9.2-1.5-.2-3t-1.1-2.8c-1.1-2.2-2.6-3.9-4.5-5.2s-4-2.2-6.4-2.6c-1.7-.3-3.4-.4-5.1-.2-1.7.1-3.4.4-5.1.8-.7.1-1.4.3-2.1.6s-1.3.6-1.9,1.1c-1,.9-1.3,1.8-1.3,2.8c0,1.1.3,2.1.6,3.2Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2122.4,956q.1.3.2.6t.2.6c.2.5.4,1,.6,1.4s.4.9.7,1.4l.2.4.2.4q.9-.1,1.9-.3.9-.1,1.9-.2q2.4-.4,4.9-.6t5-.3q1.2,0,2.3.1q1.1,0,2.2.2q1.8.1,3.5.6q1.7.4,3.3,1q.1-.9,0-1.7q0-.9-.3-1.8-.1-.7-.5-1.4c-.3-.4-.5-.9-.8-1.3q-.8-1.3-1.8-2.5t-2.1-2.3q-.3-.3-.6-.5-.3-.3-.7-.4-.5-.1-.9-.2-.5-.1-1-.2-.9-.2-1.9-.3-.9-.1-1.9-.2-1.9-.1-3.8,0t-3.8.3q-1,.2-2,.4-1,.1-1.9.3-.6.1-1.1.2t-1,.2c-.2.1-.6.2-1,.3s-.7.2-.7.4q0,1.3.1,2.7.2,1.4.6,2.7Z",
    fill: "#c4c4c4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2142.5,968.1c.4-1,.7-2.2.8-3.4s0-2.4-.3-3.5q-.1-.3-.2-.7-.2-.3-.3-.6-.3-.5-.5-.9-.3-.4-.6-.8-.1-.2-.3-.4t-.3-.3q-.5-.6-1.1-1-.5-.4-1.1-.7-.2-.1-.4-.3-.2-.1-.5-.2-.4-.2-.8-.3-.3-.1-.6-.2-.4-.2-.9-.2-.4-.1-.9-.1-.6-.1-1.1-.1-.4,0-.8.1-.6,0-1.1.1t-1,.3c-1.4.4-2.6,1.1-3.6,2-1.1.9-1.9,2-2.5,3.2l-.1.1-.1.1c.3.5.6,1.2,1,1.9.3.7.6,1.4.9,1.8.2.3.4.6.6.9.3.4.5.7.7.9s.4.3.6.4c.2,0,.4.1.6.2q.6.4,1.3.7t1.5.5q.4.1.8.1.4.1.7.1l1.5.2l1.4.2c.3,0,.7.1,1,.2.4.1.8.2,1.2.2q.6,0,1.1,0q.5-.1.9-.1c.5-.1,1-.1,1.4-.2.4,0,.7-.1,1.1-.2Z",
    fill: "#bababa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2123.7,959.3l.4.7.4.8q.9-.1,1.9-.3.9-.1,1.9-.2q2.4-.4,4.9-.6q2.4-.2,4.9-.2h.1v-.1q1.2,0,2.3.1q1.1,0,2.2.2-.2-.5-.5-.9t-.6-.8q-.1-.2-.3-.4-.1-.2-.3-.4-.5-.5-1-.9-.6-.5-1.2-.8-.2-.1-.5-.3-.2-.1-.5-.2-.4-.2-.7-.3-.4-.2-.8-.2-.4-.2-.9-.3-.4,0-.9-.1-.5,0-1,0t-1,.1q-.5,0-1.1.1-.5.1-1,.3c-1.5.4-2.9,1-4,1.8-1.2.7-2.1,1.7-2.7,2.9Z",
    fill: "#606060"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2124.1,960l.1.3.2.3q0,0,.1-.2.2-.3.4-.7c.5-.9,1.3-1.8,2.3-2.6c1-.9,2.1-1.6,3.4-1.9q.4-.2,1-.3.5-.1.9-.1.9,0,1.7,0t1.6.2t1.5.5q.8.3,1.5.8.2.1.4.3.2.1.4.2q1,.8,1.7,1.7t1.1,2q.4.9.5,1.8.2.9.2,1.8.1.8-.1,1.6-.1.8-.5,1.6-.1.3-.1.4-.1.2-.2.5c0,0,.1,0,.2-.1.2,0,.3-.1.5-.1q.1-.3.2-.6.2-.3.2-.6.4-1.1.4-2.3.1-1.1-.1-2.3-.2-.7-.4-1.4-.3-.8-.6-1.4-.1-.2-.2-.4t-.2-.4q-.1-.1-.2-.3-.1-.1-.2-.2-.7-.9-1.6-1.7-.9-.7-2-1.2-.8-.4-1.6-.7-.8-.2-1.7-.3-.6-.1-1.2-.1t-1.2.1q-.5,0-1.1.1-.5.1-1,.3c-1.5.4-2.8,1.2-3.8,2.1-1.1.9-2,2.1-2.5,3.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2126.8,965.1c.5.6,1,1.1,1.4,1.4s.8.6,1,.7c2.1,1,4.3,1.3,6.1,1.4c1.7.1,3,0,3.1,0c.8-.9,1.3-1.9,1.6-3c.3-1,.3-2.2-.1-3.4q-.2-.8-.7-1.5-.4-.7-1.1-1.2c-.8-.8-1.8-1.4-3-1.6-1.1-.3-2.3-.3-3.6.1q-1,.3-1.8.9-.8.5-1.4,1.4-.3.3-.5.5-.2.3-.4.7-.1.3-.3.7-.1.3-.2.7t-.1.7q-.1.4-.1.8q0,.2,0,.4.1.1.1.3Z",
    fill: "#020102"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2122,954.3q.1.8.3,1.5.1.7.3,1.3q0,.1.1.2q0,.1.1.2q0,0,.1.1.1,0,.2,0c2,.3,4,.2,6-.1s4-.7,5.9-1c2-.4,4.1-.7,6.1-.6c2,0,3.9.3,5.7,1q.7.3,1.3.7.7.4,1.3.8c0,0,0-.1-.1-.3c0-.1,0-.2,0-.2q0-.2-.1-.3q0-.1-.1-.3q0-.2-.1-.5t-.3-.5q-.1-.3-.2-.5-.2-.3-.3-.5t-.3-.5q-.1-.2-.2-.4-.6-.9-1.3-1.8t-1.5-1.7q-.5-.5-1.1-1-.5-.5-1.1-.9c-2.3-1.7-5.2-2.6-8.2-2.9-3.1-.3-6.2,0-9,.7-1,.3-2,.6-2.8,1.2-.7.6-1.2,1.4-1.2,2.6q0,.9.1,1.9.2.9.4,1.8Z",
    fill: "url(#eCwuQE5mxSB68-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2149.6,958.5q-.6-.2-1.2-.4t-1.3-.3q-.6-.2-1.2-.3-.7-.2-1.3-.3-1.1-.3-2.1-.4-1.1-.1-2.1-.1c-2.3.1-4.4.3-6.4.7s-3.9.9-5.9,1.5c-.8.2-1.6.4-2.5.5-.9.2-1.7.3-2.6.2q-.7-.1-1.4-.4-.6-.4-1.1-.9-.3-.2-.5-.5-.3-.3-.5-.5c-.1-.2-.2-.3-.3-.5-.1-.1-.2-.4-.4-.7.3.1.8.2,1.4.3.5.1,1.1.1,1.6.1q1.2-.1,2.4-.1q1.2-.1,2.4-.2q1.1-.1,2.2-.3t2.2-.4c2.3-.4,4.7-.9,7.1-1.1c2.4-.1,4.8.1,7.1,1.1.7.3,1.3.5,1.8.9.5.3,1,.7,1.7,1.2.2.2.4.4.6.5.2.2.3.4.3.4Z",
    fill: "#020102"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2137.8,960.5c-.1.4,0,.9.3,1.2.2.3.6.5,1,.6s.8,0,1.1-.3c.4-.2.6-.6.7-1c0-.4-.1-.8-.3-1.1-.2-.4-.6-.6-1-.7-.4,0-.9.1-1.2.3s-.5.6-.6,1Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2213.6,789.2c-2.9,1.7-5,3.2-6.7,4.9s-3,3.6-4.3,6.1c-1.3,2.4-2.4,5-2.9,7.7s-.5,5.5.3,8.1c-.1-1.2.2-2.6.7-4c.4-1.4,1-2.8,1.4-4q.6-1.9,1.4-3.7t1.6-3.7c1.1-2.3,2.3-4.4,3.7-6.3c1.4-1.8,3-3.5,4.8-5.1Z",
    fill: "#020102"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2270.3,904.9c-1.1-3.4-4-4.6-7-4.3s-6.2,2-7.9,4.3c-.5.6-1,1.3-1.5,2-.5.6-.9,1.4-1.1,2.2-.2.7-.3,1.5-.2,2.3.2.7.7,1.3,1.6,1.4.7,0,1.5-.2,2.3-.6.8-.3,1.6-.7,2.3-.9q1.3-.3,2.6-.5q1.4-.2,2.7-.2c1-.1,1.7-.2,2.5-.4.7-.2,1.4-.6,2-1.2.6-.5,1.2-1.2,1.5-2c.4-.7.5-1.5.2-2.1Z",
    fill: "url(#eCwuQE5mxSB72-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2251.4,925.1c.5-1.1,1.2-2.2,2.1-3.1s2-1.6,3.1-1.8c.9-.7,2-.7,3.1-.3c1.1.3,2.2,1,2.9,1.6.9.7,1.6,1.6,2.2,2.6.6,1.1,1,2.2,1.2,3.3.1.8.2,2.1.1,3.3-.1,1.3-.4,2.4-1.2,3.1c1.4-.9,2.6-2.2,3.5-3.7c1-1.5,1.7-3.2,2.1-4.7.3-1.3.3-2.7.1-4-.3-1.3-.7-2.5-1.4-3.7-.8-1.4-1.9-2.4-3.2-2.9-1.4-.6-2.9-.7-4.5-.4q-1.9.3-3.6,1.3t-3.1,2.5q-.5.6-1,1.2-.5.7-.9,1.4-.2.5-.5,1-.2.5-.4,1.1-.2.5-.3,1.1-.2.6-.3,1.1Z",
    fill: "#b22842"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2175.6,817.3q.3.3.3.8t-.3,1.1c-.4.8-.7,1.6-1.1,2.4-.5.8-.9,1.5-1.6,2.2-1.1,1.2-2.3,2.3-3.6,3.3s-2.6,1.9-4,2.8c-.6.4-1.3.8-2,1.2-.6.3-1.4.6-2.1.7s-1.3.1-1.9,0c-.7-.1-1.3-.3-2-.4-2.9-.3-5.7-.7-8.6-1s-5.8-.4-8.7-.4c-2.9.1-5.9.3-8.7.9-2.9.5-5.7,1.4-8.3,2.6c4.3-1.2,8.9-1.7,13.4-1.5c4.5.1,9,1,13.2,2.5q.5.2,1,.4.4.3.7.7c1,1.4-.4,2.6-2.3,3.4s-4.3,1.2-5,1.3c-1.8.2-3.5.2-5.3.1s-3.5-.3-5.3-.4c-5.1-.2-10.1-.3-15-.1-5,.2-9.9.8-14.9,1.9.3-.1.7-.4,1.2-.7.4-.4.7-.7,1-.9q.7-.5,1.4-1q.8-.4,1.5-.9q1.4-.9,2.9-1.7q1.4-.8,2.9-1.6c3.4-1.6,6.7-3.1,10.2-4.6c3.4-1.4,6.8-2.7,10.4-3.9q-3.7.3-7.3,1.1-3.5.8-7,1.9-1.8.6-3.5,1.2-1.8.6-3.5,1.3-.5.1-.9.3t-.9.3c-.2.1-.5.3-.8.4s-.5.3-.7.2c-.5,0-.5-.2-.4-.5.2-.2.5-.5.6-.7q.7-.6,1.3-1.2.7-.6,1.4-1.2q1.4-1.1,2.9-2.1t3.1-1.8q1.8-1,3.6-1.9q1.9-.9,3.7-1.7c3.9-1.7,7.7-3.3,11.7-4.5c3.9-1.3,7.9-2.2,12.1-2.6q5.9-.5,11.7-.2q5.9.3,11.7,1.6.6.1,1.1.3t.7.6Z",
    fill: "url(#eCwuQE5mxSB75-fill)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M2265.2,1355q-3.1.1-6.2.1-3.2.1-6.3.1-3.8.1-7.4.1-3.7.1-7.4.1-1.3,0-2.6.1-1.4,0-2.7,0-8.2.1-16.3.2t-16.2.1q-3.2,0-6.4,0-3.1,0-6.3,0c-2.4-.1-5.1.1-7.7.3-2.7.1-5.3.1-7.6-.3l-.1-.1h-.1c-3.7-.7-7-2.2-10.4-3.5s-6.8-2.4-10.5-2.4q-.5-.1-1-.1t-1.1.1c-3.2.2-6.2,1.2-9.3,2.3-3,1.1-5.9,2.3-9.1,2.9q-.7.1-1.4.2t-1.5.2q-1.1.1-2.2.1t-2.2-.1q-.5.1-1.1.1t-1.2-.1q-2.1,0-4.3-.1-2.1-.1-4.1-.2-.7,0-1.3,0t-1.3-.1q-.5,0-1,0t-1,0q-1.1-.1-2.1-.1-1-.1-2-.1c-.6,0-1.1-.1-1.6-.2s-1-.1-1.5-.1q0-.1,0-.2.1-.2,0-.3.1,0,.1-.1q0,0,0,0c.3-.6.6-1.1,1-1.7.4-.5.8-1,1.2-1.4q.9-1.1,1.8-2.2.9-1,1.9-2.1c4.6-4.5,9-9.1,13.6-13.4c4.7-4.4,9.5-8.5,14.8-12.3c1.8-1.2,4-2.1,6.3-2.5c2.3-.5,4.7-.4,6.8.4q4.4,1.6,8.8,3.2q4.5,1.5,8.9,3c2.6,1,5.2,1.9,7.8,2.7s5.3,1.3,8,1.4c4.5.1,8.9-.6,13.3-1.6c4.3-1,8.7-2.3,12.9-3.6q4.4-1.3,8.7-2.7q4.4-1.4,8.7-2.9.1,0,.2,0t.2,0q5.4-1.7,10.8-3.5q5.5-1.7,10.9-3.6q1.5-.5,3.1-1q1.5-.5,3-1q0,.2.1.4q0,.2,0,.4c.4,2.2,1,4.4,1.9,6.6.8,2.2,1.7,4.4,2.6,6.6q.3.6.5,1.2t.4,1.2q.6,1.4,1.1,2.8.4,1.4.8,2.8.5,2.1.9,4.2.5,2,.8,4.1.7,3.6,1.3,7.1.6,3.6,1.1,7.1l.1.7.1.7Z",
    fill: "url(#eCwuQE5mxSB76-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2265.2,1355q-3.1.1-6.2.1-3.2.1-6.3.1-3.8.1-7.4.1-3.7.1-7.4.1-1.3,0-2.6.1-1.4,0-2.7,0-8.2.1-16.3.2t-16.2.1q-3.2,0-6.4,0-3.1,0-6.3,0c-2.4-.1-5.1.1-7.7.3-2.7.1-5.3.1-7.6-.3l-.1-.1h-.1c-3.7-.7-7-2.2-10.4-3.5s-6.8-2.4-10.5-2.4q-.5-.1-1-.1t-1.1.1c-3.2.2-6.2,1.2-9.3,2.3-3,1.1-5.9,2.3-9.1,2.9q-.7.1-1.4.2t-1.5.2q-1.1.1-2.2.1t-2.2-.1q-.5.1-1.1.1t-1.2-.1q-2.1,0-4.3-.1-2.1-.1-4.1-.2-.7,0-1.3,0t-1.3-.1q-.5,0-1,0t-1,0q-1.1-.1-2.1-.1-1-.1-2-.1c-.6,0-1.1-.1-1.6-.2s-1-.1-1.5-.1q0-.1,0-.2.1-.2,0-.3c1.4-.2,2.7-.3,4-.4c1.4,0,2.8-.1,4.3-.1h.1q.6,0,1.1-.1.6,0,1.2-.1h.1c2.8-.3,5.4-.9,8.1-1.6s5.3-1.5,7.9-2.4q.1,0,.1,0t0,0q1-.4,2-.8t2-.7c4-1.4,8-2.9,12-4c4.1-1.1,8.2-1.9,12.5-2.1c4.9-.2,9.8.6,14.7,1.5c4.8.9,9.7,2.1,14.6,2.6c4.3.4,8.6.4,12.9.2s8.7-.6,13-1.1q7.6-.7,15.2-1.5t15.3-1.6q4.5-.5,9-1q4.6-.5,9.1-1.1.7,0,1.4-.1t1.3-.2q.7,3.6,1.3,7.1.6,3.6,1.1,7.1l.1.7.1.7Z",
    fill: "url(#eCwuQE5mxSB77-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2260.1,1339.2q0,.1,0,.3-.1.1-.2.2c-.3,1.8-1,3.4-1.8,4.9-.7,1.5-1.5,2.9-2.1,4.6q-.6,1.7-1.4,3.2t-1.9,2.8q-3.8.1-7.4.1-3.7.1-7.4.1c.8-1.9,1.6-4.1,2.3-6.5.6-2.3,1.2-4.7,1.6-7.1.2-1.8.4-3.6.4-5.3-.1-1.7-.3-3.4-.7-4.9-.5-2.1-1.4-4.1-2.5-6-1.1-1.8-2.6-3.4-4.3-4.7-1.2-.9-2.5-1.6-4-2.1-1.4-.5-2.9-.8-4.4-.7q-.1,0-.3,0t-.3.1q5.4-1.7,10.8-3.5q5.5-1.7,10.9-3.6q2.1,1.2,4,2.8q1.8,1.6,3.3,3.5q1,1.3,1.9,2.8.9,1.4,1.5,2.9.3.6.5,1.2t.4,1.2c.7,2.2,1.2,4.4,1.4,6.7s.1,4.7-.3,7Z",
    fill: "url(#eCwuQE5mxSB78-fill)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2142.3,1330v.8.8c-3.5-.1-6.9,1-9.9,2.7-3.1,1.7-5.9,3.9-8.2,6q-3.9,3.4-7.5,7.1t-6.8,7.7q-.5-.1-1-.1t-1,0q3.4-4.4,7.3-8.3q3.8-4,7.9-7.6c2.5-2.2,5.4-4.5,8.6-6.3c3.3-1.7,6.8-2.9,10.6-2.8Z",
    fill: "#e89477"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2151,1339.1v.8.8q-1.6.1-3.1.1-1.6.1-3.2.3c-.9.1-1.8.2-2.8.3-1,.2-1.9.5-2.9.9s-1.9.9-2.8,1.6c-.8.6-1.7,1.4-2.7,2.3q-2.6,2.2-5.2,4.6-2.6,2.3-5.1,4.7-.5,0-1.1,0t-1.2,0q2.8-2.7,5.7-5.4q3-2.6,5.9-5.1c.8-.7,1.7-1.5,2.7-2.3.9-.7,2-1.4,3.2-1.9c1-.4,2.1-.7,3.1-.9c1.1-.2,2.1-.3,3.1-.4q1.5-.1,3.2-.2q1.6-.1,3.2-.2Z",
    fill: "#e89477"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M2295.9,1044.8c-1.6,8.8-4.4,17.4-8.5,25.3s-9.4,15.1-16,21.1c-3.9,3.6-8.2,6.7-12.7,9.6-4.4,2.9-9,5.5-13.6,8.1q-3.4,2-6.7,3.9-3.4,1.9-6.7,3.8.3-6.9-.6-13.8t-2.8-13.5q0-.3-.1-.5-.1-.3-.2-.5c-2.2-.6-4.3.1-6.1,1.5-1.8,1.3-3.4,3.2-4.7,5-2.6,3.9-4.8,8.1-6.5,12.5-1.8,4.3-3.1,8.9-3.8,13.5-.7-5.6.1-11.3,2-16.6c1.8-5.4,4.7-10.4,8.1-14.9s7.4-8.6,11.6-12.3c4.2-3.8,8.7-7.4,13.1-10.9s8.9-7,13-10.9c4.2-3.8,8.2-7.8,11.6-12.4q1.6-2.2,3-4.5q1.5-2.3,2.9-4.6c.8-1.4,1.6-2.8,2.5-4.1.8-1.4,1.7-2.8,2.4-4.2q1.4-2.7,2.3-5.6q1-2.8,1.6-5.8.2-.7.3-1.5.2-.7.3-1.4.1-.5.1-.9.1-.5.1-1q0-.1,0-.3t-.1-.3c0-.4-.3-.9-.6-1.3-.4-.4-.7-.9-1-1.2q-.4-.6-.9-1.2-.4-.6-.8-1.2c-2-2.6-3.9-5.1-5.6-7.8s-3.3-5.5-4.6-8.5q-.3-.6-.5-1.3-.3-.6-.6-1.3c-.4-1-.8-2-1.1-2.8-.3-.7-.4-1.2-.4-1.2.5.1,1.4.3,2.2.5s1.6.4,2.1.5q1.5.4,3.1.8q1.5.5,3.1,1q1.8.6,3.7,1.2t3.8,1.1q1,.4,2,.7q1.1.3,2.2.6.8.2,1.6.5t1.4.8c.5.5.8,1,1.1,1.6s.4,1.3.6,1.8c2.4,8.6,4,17.4,4.6,26.3.7,8.9.3,17.8-1.2,26.6Z",
    fill: "url(#eCwuQE5mxSB84-fill)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2224.8,1136c0,.8-.3,1.4-.7,1.9-.5.5-1.2.8-1.9.8s-1.4-.3-1.8-.8c-.5-.5-.8-1.1-.8-1.9c0-.7.3-1.3.8-1.8.4-.5,1.1-.8,1.8-.8s1.4.3,1.9.8c.4.5.7,1.1.7,1.8Z",
    fill: "#8b758e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2233.2,1185.9c0,.7-.3,1.4-.8,1.8-.5.5-1.1.8-1.8.8s-1.4-.3-1.9-.8c-.4-.4-.7-1.1-.7-1.8s.3-1.4.7-1.9c.5-.4,1.2-.7,1.9-.7s1.3.3,1.8.7c.5.5.8,1.2.8,1.9Z",
    fill: "#8b758e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2235.3,1230.5c0,.7-.3,1.4-.8,1.8-.5.5-1.1.8-1.9.8-.7,0-1.3-.3-1.8-.8-.5-.4-.8-1.1-.8-1.8s.3-1.4.8-1.9c.5-.4,1.1-.7,1.8-.7.8,0,1.4.3,1.9.7.5.5.8,1.2.8,1.9Z",
    fill: "#8b758e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2232.3,1279.2c0,.7-.2,1.4-.7,1.9-.5.4-1.1.7-1.9.7-.7,0-1.3-.3-1.8-.7-.5-.5-.8-1.2-.8-1.9s.3-1.3.8-1.8s1.1-.8,1.8-.8c.8,0,1.4.3,1.9.8s.7,1.1.7,1.8Z",
    fill: "#8b758e"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2182.5,1196.8c.3,8.4.6,16.4,1.1,24.3q0,.8-.2,1.5-.3.8-.8,1.4t-1.2.9-1.6.3l-2.7-.1h-2.8c-6.4-.1-13-.2-19.6-.1-6.5.1-13.1.4-19.6,1h-.3q-.7,0-1.3-.3-.6-.2-1.1-.7t-.8-1.1q-.3-.7-.4-1.5c0-9.2-.2-18.1-.8-26.7-.5-8.7-1.4-17-2.5-25.3q-.1-.8.1-1.6.3-.7.9-1.3.5-.6,1.2-.9.8-.2,1.6-.2q11.5.8,23.1.9q11.6,0,23.1-.8.9,0,1.7.3t1.5.9q.6.6.9,1.4.4.7.4,1.6c-.1,9.1-.1,17.7.1,26.1Zm-27-19.6l24.6-.3v-6.2q0-.4-.2-.7-.1-.4-.4-.7-.3-.2-.6-.4-.4-.1-.8-.1c-7.7.5-15.5.7-23.3.7-7.8-.1-15.5-.3-23.2-.9q-.1,0-.1,0t-.1,0q-.2,0-.5.1t-.4.3q-.2.2-.3.5t-.1.6q.3,1.8.5,3.7.2,1.8.4,3.7q0,0,0,0t0,0l24.5-.3Zm25.8,44.8q.1-.4,0-.7-.6-10-.9-20.5t-.4-21.6v-.1l-24.3.4-24.4.3q0,0,0,0q0,.1,0,.1c.7,6.8,1.3,13.6,1.7,20.7.3,7.1.5,14.3.5,21.8q0,.3.1.6.1.2.3.4t.5.3q.2.1.5.1c6.5-.6,13.1-.9,19.7-1c6.6,0,13.2,0,19.7.1h5.5q.4,0,.6-.1.3-.1.5-.3t.4-.5Z",
    fill: "url(#eCwuQE5mxSB91-fill)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2213.8,1168.4q-.6-7-1.4-14-.7-7-1.5-14-.4-3.5-.8-7t-.8-7q-.2-1.7-.4-3.5-.2-1.7-.4-3.4c-.3-2-.3-3.3-.4-4.6-.1-1.2-.3-2.5-.7-4.4-.2-1.2-.5-2.3-.9-3.3-.3-1-.6-1.9-.8-2.4-.4-1.4-.7-2.4-1.1-3.2-.3-.9-.6-1.7-1-2.6q.4,2.5.7,5.1.3,2.5.4,5.1.1,1.2.2,2.3q0,1.1.3,2.3.2.8.4,1.6t.3,1.6q.2,1.4.4,2.8.1,1.4.3,2.8.3,2.8.7,5.6.3,2.8.6,5.5.7,5.7,1.3,11.4.6,5.6,1.2,11.3q1.5,14,2.6,28.1q1.2,14,1.8,28.1.7,14.1.8,28.2.1,14.2-.5,28.3c-.5,9.4-1.1,18.3-2,27.2-1,8.9-2.2,17.7-3.9,27l1.3-.4l1.3-.3c.4.1,1.6-9.4,2.6-19.3c1.1-9.9,2.1-20.2,2.2-22.1q1-14.1,1.2-28.2t-.2-28.3q-.5-14.1-1.4-28.2-1-14.1-2.4-28.1Z",
    fill: "url(#eCwuQE5mxSB92-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2360.6,1095.5l.4,1.1c-1.9.5-3.7,1.1-5.5,1.8-1.8.8-3.5,1.6-5.3,2.4-5.7,2.6-11.3,5.9-16.3,9.9-5,3.9-9.5,8.5-13.1,13.8-3.8,5.4-6.7,11.1-8.9,17-2.2,6-3.8,12.2-4.8,18.7-2.1,12.5-2.9,25.3-3.2,38.1-.2,12.7.1,25.5.4,38q0,.1,0,.2t0,.2q0,1.2.1,2.5q0,1.2,0,2.5.1,2.3.1,4.6.1,2.3.1,4.6.1,2.8.2,5.6.1,2.9.1,5.7.1,2.8.2,5.6q0,2.8.1,5.7.1,2.3.1,4.5.1,2.3.1,4.6.1.8.1,1.6t0,1.6q0,.6.1,1.3q0,.6.1,1.2c3.4.3,6.8.9,10.1,1.9c3.3,1.1,6.5,2.5,9.6,4.4l-.6,1-.6.9c-7.4-4.7-15.8-6.3-24-6.2s-16.2,1.9-22.8,4c-3.3,1-6.6,2.2-9.8,3.4-3.3,1.2-6.5,2.5-9.6,3.8-4.4,1.8-6.2,2.8-8,3.7-1.8.8-3.7,1.5-8.4,2.6l-.2-1.1-.2-1.1c4.6-1.1,6.5-1.8,8.2-2.6s3.4-1.8,7.7-3.5c3.2-1.3,6.4-2.6,9.7-3.9s6.6-2.4,9.9-3.5c3.8-1.2,8.1-2.2,12.6-3c4.5-.7,9.3-1.1,14.1-.9q0-.1,0-.2t0-.2q-.1-1.7-.1-3.4-.1-1.7-.1-3.3-.1-2.6-.2-5.1q0-2.5-.1-5-.1-2.9-.1-5.9-.1-2.9-.2-5.8-.1-2.8-.1-5.6-.1-2.8-.2-5.6q0-2.1-.1-4.2q0-2.1-.1-4.2q0-.8,0-1.7q0-.8-.1-1.6q0-2.9-.1-5.7q0-2.9-.1-5.8-5.8.3-11.8.4-6.1.2-12.1.2-4.3,0-8.6-.1t-8.4-.2c-1.1,0-2.2-.5-2.9-1.3-.8-.8-1.2-1.8-1.3-2.9l-1.1-28.3-1-28.3c-.1-.2-.1-.6,0-1s.3-.8.7-1.2q.4-.2.8-.3.3-.1.6-.1q12-1.5,24.1-2.2t24.2-.6c1.9-11.2,5.6-22,11.4-31.5c5.7-9.4,13.5-17.6,23.3-23.6c4.8-3,9.4-5.2,13-6.7c3.7-1.6,6.4-2.5,7.5-2.8l.4,1.1Zm-58.8,101.7c.2-8.5.7-17.1,1.6-25.6-7.2.3-14.9.5-22.7.7-7.7.2-15.5.4-22.7.6h-.4-.5l.9,24l1,23.9c0,.6.2,1.1.6,1.5.3.4.8.6,1.4.6c6.5.2,13.4.3,20.3.3c6.9-.1,13.8-.2,20.5-.6-.2-8.4-.2-16.9,0-25.4Zm2.4-31.9q.2-2.1.5-4.1c-7.9,0-15.9.2-23.9.6-8,.5-16,1.2-23.9,2.2q-.1-.1-.1,0t0,.3l.1,3.2.1,3.2h.5l.5-.1c7.2-.1,15-.3,22.8-.6c7.8-.2,15.6-.4,22.9-.6q.2-2.1.5-4.1Z",
    fill: "url(#eCwuQE5mxSB93-fill)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2119.1,1125.5q-.5.1-1,.2t-1.1.2c-.4,0-.5,4-.5,8.1.1,4.1.2,8.4.2,9.1q0,5.4.1,10.8t.2,10.8c.1,6.2.4,13.1.7,19.9.3,6.9.6,13.7.9,19.9c1.4,32,2.1,55.3,2.1,70.7s-.5,22.9-1.5,23.5q.5-.3,1-.6.5-.4.9-.7q0,1.2-.1,2.4t-.2,2.5q0-.3.1-.5q0-.2.1-.5c2.3-9.2,2.3-30.9,1.6-54.9s-2.1-50.4-2.7-69.2c-.3-8.4-.5-16.8-.7-25.4-.2-8.5-.2-17.2-.1-26.3Z",
    fill: "url(#eCwuQE5mxSB94-fill)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M2282.4,992.6q.6.5,1,1.2t.4,1.5q-.1,1.2-.1,2.4-.1,1.2-.2,2.4-.3,2.3-.7,4.6t-1,4.5c0-.3-.4-.9-.8-1.5-.4-.7-.9-1.3-1.3-1.8q-1-1.2-1.7-2.1-.7-.8-1.2-1.4c-1.5-2-2.5-3.7-3.5-5.4-1-1.6-1.9-3.4-3.1-5.6-.3-.5-.5-.8-.7-1.2-.2-.5-.4-.9-.7-1.7c0,.1.4.2.9.2s.9.1,1,.1c1.3.1,2.4.3,3.5.6c1,.3,2.1.7,3.3,1.1.6.3,1.5.5,2.5.8.9.3,1.8.7,2.4,1.3Z",
    fill: "#746277"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2290.4,1350.2q-.9,1.3-2.2,2.5-1.2,1.2-2.7,2c-1.2.6-2.6.9-4,1.1-1.4.3-2.8.3-4.2.4q-.7,0-1.3.1-.7,0-1.4.1c-2.3.2-4.5.5-6.8.7s-4.6.4-6.9.4c-1.2,0-2.1.1-3.2.2-1.2.1-2.4.1-4.3.1-.8,0-1.4,0-2-.1-.5,0-1-.1-1.5-.2-.8-.2-1.4-.5-2.1-.9q-.9-.5-1.9-1.2c1.4-1.9,2.9-4.1,4.3-6.3c1.3-2.3,2.4-4.7,2.9-7c.4-2.3.5-4.7.1-7-.4-2.4-1.1-4.6-2.2-6.8-1.2-2.5-3-4.9-5-7s-4.3-3.8-6.8-5.1c-.3-.2-.7-.5-1.2-.7-.4-.3-.9-.5-1.3-.5-.4-.1-.9,0-1.5.2-.5.1-1.1.3-1.5.4-.9.3-1.8.7-2.8,1s-2,.6-3.3.9c0,.1,0-.6,0-1.4.1-.7.1-1.7.3-2.2.2-1.3.7-2.2,1.4-2.9.8-.7,1.6-1.3,2.6-2.1q.3-.2.6-.4t.7-.5q.7-.5,1.4-1t1.4-.9q2-1.3,4.1-2.5q2.2-1.2,4.4-2.1c.6-.3,1.2-.6,1.9-1c.6-.3,1.2-.6,1.9-.8.8-.2,1.7-.2,2.7-.2.9-.1,1.8,0,2.7.1c4.6.4,9.1,2.2,13.3,4.5c4.2,2.4,8.1,5.4,11.6,8.2q1.6,1.3,3.1,2.6q1.5,1.4,3,2.9q1,1,1.9,2q.9,1.1,1.7,2.3c2.8,4,4.7,8.8,5.3,13.8.5,4.9-.4,10-3.2,14.3Z",
    fill: "url(#eCwuQE5mxSB96-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2295.9,1044.8c-1.6,8.8-4.4,17.4-8.5,25.3s-9.4,15.1-16,21.1c-3.9,3.6-8.2,6.7-12.7,9.6-4.4,2.9-9,5.5-13.6,8.1q-3.4,2-6.7,3.9-3.4,1.9-6.7,3.8c.2-4.6-.1-9.5-.7-14.3-.7-4.8-1.7-9.6-3-14q1.2-.6,2.5-1.1c.8-.3,1.6-.6,2.4-1c3.8-1.7,7.5-3.5,11-5.4c3.6-2,7-4.2,10.1-6.8c6.5-5.3,12.2-11.3,17.2-18c5-6.6,9.2-13.9,12.4-21.6c1.5-3.5,2.7-6.9,3.6-10.4s1.5-7,2-10.7c.1-.9.7-7.2,1.1-13.3s.6-11.9.1-11.8c.7.4,1.2,1,1.5,1.7.4.8.6,1.5.8,2.1c2.4,8.6,3.9,17.4,4.5,26.3.6,8.8.2,17.7-1.3,26.5Z",
    fill: "url(#eCwuQE5mxSB97-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2290.4,1350.2q-.9,1.3-2.2,2.5-1.2,1.2-2.7,2c-1.2.6-2.6.9-4,1.1-1.4.3-2.8.3-4.2.4q-.7,0-1.3.1-.7,0-1.4.1c-2.3.2-4.5.5-6.8.7s-4.6.4-6.9.4c-1.2,0-2.2.2-3.9.3-1.6.1-3.8,0-7.1-.3-.8-.2-1.4-.5-2.1-.9q-.9-.5-1.9-1.2c1.4-1.9,2.9-4.1,4.3-6.3c1.3-2.3,2.4-4.7,2.9-7c.4-2.3.5-4.7.1-7-.4-2.4-1.1-4.6-2.2-6.8-1.2-2.5-3-4.9-5-7s-4.3-3.8-6.8-5.1c-.3-.2-.7-.5-1.2-.7-.4-.3-.9-.5-1.3-.5-.4-.1-.9,0-1.5.2-.5.1-1.1.3-1.5.4-.9.3-1.8.7-2.8,1s-2,.6-3.3.9c0,.1,0-.6,0-1.4.1-.7.1-1.7.3-2.2.2-1.3.7-2.2,1.4-2.9.8-.7,1.6-1.3,2.6-2.1q.3-.2.6-.4t.7-.5c3.1-.3,6.3.1,9.4,1c3,.9,5.9,2.4,8.3,4.4c3,2.5,5.4,5.6,7,9.2c1.6,3.5,2.4,7.4,2.2,11.3c3.4,0,6.7-.7,9.8-2.1c3-1.3,5.9-3.2,8.3-5.5q1.9-1.9,3.6-4q1.6-2.2,2.9-4.5q1,1,1.9,2q.9,1.1,1.7,2.3c2.8,4,4.7,8.8,5.3,13.8.5,4.9-.4,10-3.2,14.3Z",
    fill: "url(#eCwuQE5mxSB98-fill)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2066.2,1309.8q0,.4,0,.8-.1.4-.2.8-.1.9-.4,1.8t-.7,1.8q-.1.3-.3.6t-.4.6q-.1.3-.4.7-.2.3-.4.7-.7,1-1.4,1.9-.8.9-1.7,1.9-.8.9-1.7,1.7t-1.8,1.6q-1.4,1.2-2.7,2.2t-2.4,1.8q-.1,0-.2.1t-.4.2q-.1.1-.2.2t-.2.1q-.5.3-1,.6-.6.3-1.3.7c-1.3.8-2.9,1.7-4.4,2.6s-2.8,1.6-3.7,2.1q-2.5,1.3-5,2.6-2.4,1.3-4.9,2.7c-3.1,1.9-6.2,3.9-9.4,5.8-3.1,1.8-6.3,3.6-9.6,5.1q-.4.2-.8.5-.5.2-.9.4-.5.3-1,.5t-1,.5q-.8.3-1.6.6t-1.7.5q-1.9.4-3.9.6t-4,.2q-1.2,0-2.4-.1t-2.3-.2q-3-.2-5.9-.5t-5.8-.5q-1.6-.2-3.2-.3-1.7-.1-3.3-.4-.3,0-.5-.1-.3,0-.6-.1-1.8-.3-3.5-.7-1.8-.5-3.6-1c-1-.3-2-.7-2.9-1.1-1-.4-1.9-.9-2.7-1.6q-.2-.1-.3-.3t-.1-.4.2-.4q.1-.2.3-.3c2-1.6,4.1-3.2,6.2-4.9c2-1.6,4.1-3.3,6-5.1c1.8-1.8,3.2-1.9,4.6-2c1.3-.1,2.7-.3,4.4-2.1c6.3-6.4,10.6-11.8,13.8-16.4c3.3-4.7,5.4-8.7,7.4-12.4q1.1-2.1,2.2-4.1q1.2-2,2.4-4v-.1q0,0,.1,0q0-.1,0-.1c.6-1.1,1.6-2.4,2.6-3.6c1-1.3,2.1-2.4,3.2-3.2q.3-.2.5-.4.2-.1.5-.2.4-.2,1-.2.5-.1.9-.1c3,.1,6,.1,9,.2c2.9.1,5.9.4,8.7.9c2.3.5,4.4,1.3,6.4,2.3c2.1.9,4.1,1.8,6.4,2.3q1.5.4,3,.8t2.9,1q2.4.9,4.6,2.1q2.3,1.3,4.2,2.9c.7.6,1.3,1.1,2,1.7.6.7,1.2,1.3,1.7,2q.4.7.7,1.3t.5,1.2q.3.7.3,1.4.1.7.1,1.3Z",
    fill: "url(#eCwuQE5mxSB100-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2065.9,1312q0,.4-.1.8t-.3.7q-.2.7-.5,1.4t-.8,1.3q-.1.4-.4.7-.2.4-.4.8-.4.4-.7.9-.4.5-.7.9c-.2.2-1.8,1.9-4.1,3.9-2.3,2.1-5.2,4.7-8.1,6.7q-.6.4-1.3.9t-1.5,1c-.8.5-1.5,1-2.2,1.4-.6.4-1.1.8-1.3.9q-5.9,3.7-11.9,7.1t-12.1,6.4q-2.5,1.3-4.9,2.4-2.5,1.2-4.9,2.3-.5.2-1,.5-.5.2-1,.4-.8.4-1.6.7t-1.7.4q-1.9.5-3.9.7t-4,.1q-1.2,0-2.4-.1-1.2,0-2.3-.1-3-.2-5.9-.5t-5.8-.5q-1.6-.2-3.2-.3-1.7-.2-3.3-.4c2.8-1.2,5.7-2.3,8.5-3.4c2.9-1.1,5.7-2.2,8.5-3.5c3.3-1.5,6.6-3,9.9-4.6c3.2-1.7,6.4-3.4,9.4-5.4c3.4-2.3,6.6-5,9.8-7.7c3.1-2.7,6.2-5.6,9.2-8.3c3.2-2.8,6.3-5.7,9.4-8.7c3-3,6-6,8.8-9.2q1.4-1.6,2.6-3.2q1.2-1.7,2.4-3.4q2.4.9,4.6,2.1q2.3,1.2,4.2,2.9c.7.5,1.3,1.1,2,1.7.6.6,1.2,1.3,1.7,2q1.2,1.8,1.5,3.6.3,1.9-.2,3.7Z",
    fill: "url(#eCwuQE5mxSB101-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2066.2,1309.8q0,.4,0,.8-.1.4-.2.8-.1.9-.4,1.8t-.7,1.8q-.1.3-.3.6t-.4.6q-.1.3-.4.7-.2.3-.4.7-.7,1-1.4,2-.6.9-1.5,1.9-.9.9-1.7,1.7-.9.9-1.8,1.7c-1.3,1-2.6,2.1-4,3.2-1.4,1-2.9,2-4.3,2.8q-.1,0-.2.1t-.1,0c-.1-.6-.1-1.4-.1-2.1c0-.8,0-1.6,0-2.2-.3-5.6-2.7-10.8-6.3-15.1-3.6-4.2-8.4-7.5-13.8-9.2-4-1.3-8.5-1.7-13-1.3-4.5.3-8.9,1.4-12.9,3.3.8-1.4,1.5-2.7,2.3-4.1.7-1.4,1.5-2.8,2.4-4.2.8-1,1.7-2.3,2.7-3.5c1-1.3,2-2.5,3.1-3.3q.3-.2.5-.4.2-.1.5-.2.4-.2,1-.2.5-.1.9-.1c3,.1,6,.1,9,.2c2.9.1,5.9.4,8.7.9c2.3.5,4.4,1.3,6.4,2.3c2.1.9,4.1,1.8,6.4,2.3q1.5.4,3,.8t2.9,1q2.4.9,4.6,2.1q2.3,1.3,4.2,2.9c.7.6,1.3,1.1,2,1.7.6.7,1.2,1.3,1.7,2q.4.7.7,1.3t.5,1.2q.3.7.3,1.4.1.7.1,1.3Z",
    fill: "url(#eCwuQE5mxSB102-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2090.2,1320.9c-1.7,3.2-4.7,5.8-8,7.9s-7,3.7-10.3,4.9c-2,.8-4,1.3-6,1.5-2.1.2-4.1.2-6.2,0q-1.8-.1-3.5-.4t-3.3-.7c-.4-.2-1.4-.5-2.5-.9-1.2-.4-2.4-.9-3.3-1.3c1.4-.9,2.2-1.5,2.9-2s1.3-.9,2.2-1.5q1.6-1.1,3.2-2.4q1.6-1.2,3.1-2.6c.8-.8,1.7-1.7,2.4-2.6.8-.9,1.5-1.9,2.1-2.9.6-1.1.6-2,.3-3-.2-.9-.8-1.9-1.4-2.9-2-3.9-5-7.5-8.4-10.3-3.5-2.9-7.5-5.2-11.8-6.5q-2.3-.7-4.7-1.1-2.3-.5-4.8-.6c-3.4-.3-6.8-.1-10.2.4-3.3.4-6.7,1.3-10,2.3q-1.2.4-2.5.8-1.2.5-2.4,1.1c-.7.3-1.4.7-2.1,1.2-.6.4-1.3.9-1.8,1.5-.1.2-.5.6-.9,1s-.7.9-.7,1.1q-.4-1.5-.6-3-.1-1.5,0-3q.1-.6.2-1.1.1-.6.3-1.1c.7-2.3,1.9-4.3,3.4-6.2c1.4-1.9,3.1-3.7,4.7-5.3c2-2,4.1-3.9,6.4-5.7c2.3-1.7,4.7-3.1,7.3-4.1c2.9-1.1,5.8-1.6,8.9-1.8c3-.2,6,0,9.1.2c5.5.4,11.1,1.3,16.6,2.8c5.4,1.6,10.5,3.8,15.2,7.2c3.3,2.3,6.2,5.1,8.7,8.3c2.4,3.1,4.5,6.6,6.1,10.3c1.4,3,2.8,6.6,3.4,10.1.7,3.6.6,7.2-1.1,10.4Z",
    fill: "url(#eCwuQE5mxSB103-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2073.4,1315c.2,1.3.2,2.7,0,4.1-.2,1.3-.6,2.6-1.3,3.8-1.2,2.4-3.3,4.2-5.8,5.3s-5.3,1.6-8.1,1.4c-1-.1-2.1-.2-3.2-.3-1.1-.2-2.1-.4-3.1-.7c1.1-.8,2.2-1.6,3.3-2.5s2.2-1.8,3.2-2.7c.8-.9,1.7-1.7,2.5-2.6.7-1,1.5-1.9,2-3c.6-1,.6-2,.4-2.9-.3-1-.9-1.9-1.4-2.9-2.1-4-5-7.5-8.5-10.4s-7.5-5.1-11.7-6.4q-2.4-.7-4.7-1.2-2.4-.4-4.8-.6c-3.5-.2-6.9,0-10.2.6-3.4.5-6.7,1.3-10.1,2.2-1.9.5-3.4,1.2-4.7,2.1s-2.3,2-3.3,3.2c-.1.1-.6,1-1.1,1.8s-.9,1.7-.9,1.9c-.3-1-.6-2.6-.8-4.2-.2-1.5-.3-3.1-.1-4.1q0-.6.1-1.1.2-.6.3-1.1.3-.2.6-.3t.5-.3q2.3-1.1,4.6-2.2q2.3-1,4.7-1.8q4.8-1.8,9.8-2.7q5.1-1,10.3-1.1c5.9-.1,11.9.9,17.4,2.9c5.6,2,10.8,5,15.1,9c2.3,2.3,4.4,4.8,6,7.6c1.6,2.9,2.7,6,3,9.2Z",
    fill: "url(#eCwuQE5mxSB104-fill)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1961.4,1344.9c1.2.6,2.5,1.5,3.7,2.5c1.3,1.1,2.7,2.3,4.1,3.3c1.2.8,2.4.8,3.6.6c1.3-.2,2.6-.6,4-.6s2.8-.3,4-.9c1.3-.6,2.4-1.5,3.2-2.6.7-1.1,1.1-2.4,1.1-3.7.1-1.4-.3-2.7-1-3.8-.6-1.1-1.6-1.9-2.6-2.6-1.1-.7-2.2-1.3-3.4-1.8q-2.9-1.2-5.9-2-3-.9-6-1.6c-1.9-.4-3.7-.7-5.5-.9-1.9-.2-3.7-.2-5.5.2-3.1.6-5.8,2.1-8.2,4.1s-4.5,4.4-6.3,7c-.3.4-.6.9-.8,1.4s-.2,1-.1,1.5c.7.1,1.3-.1,1.8-.4s.9-.7,1.5-1c.8-.5,1.8-.7,2.9-.8c1-.2,2-.2,3-.2q3.2-.1,6.3.5t6.1,1.8Z",
    fill: "url(#eCwuQE5mxSB106-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1998.5,1353.9c-.1.8-.4,1.3-.7,1.6-.3.4-.8.7-1.5,1-.4.2-.8.3-1.3.4-.4,0-.9,0-1.4.1-1.7.1-3.6.1-5.5.1-2,0-3.9,0-5.4.1-1.3.1-2.6.2-3.9.3s-2.5.1-3.6.1c-.9.1-2.1.2-3.2.2s-2.2-.1-3-.3c-.9-.2-1.5-.7-2-1.4-.5-.6-.9-1.5-1-2.3q-.1-.4-.1-.7q0-.4.1-.7q0-.6.1-1.1t.4-.9c.5-.9,1.2-1.5,2-2.1.8-.5,1.7-.9,2.6-1.2.9-.2,1.8-.4,2.7-.6c1-.2,1.9-.4,2.9-.7q.3,0,.6-.2t.5-.5q0-.1,0-.1.1-.1,0-.2.1-.1.1-.2q0-.2-.1-.4q0-.4-.1-.8t-.2-.7c-.2-.8-.4-1.6-.7-2.3s-.7-1.4-1.1-2c-.7-.9-1.8-1.5-2.9-1.8-1.1-.4-2.3-.5-3.4-.4-1.9.2-3.4.9-4.7,1.8-1.3.8-2.3,1.9-2.9,2.7-1.7,1.9-3,3.9-4.2,5.8-1.3,2-2.5,3.9-4.1,5.7q-.4.4-.8.8-.3.4-.7.8-.2.3-.5.5t-.6.4q-.3.1-.6.2-.4.1-.8.1-.4.1-.9.2-.4.1-.8.1-.7.2-1.4.3-.6.1-1.3.2-.2,0-.5.1-.2,0-.4,0-.6.1-1.2.1-.7,0-1.3,0c-.7,0-1.5,0-2.4,0-1,0-2,.1-3,.1h-.4-.4c-1.3,0-2.5,0-3.5,0-1.1,0-1.9,0-2.3-.1-.7-1.6.4-5.6,2.1-9.5c1.6-3.9,3.6-7.8,4.7-9.1c1.7-2,3.7-3.4,5.6-4.5c1.9-1,3.6-1.7,4.7-2.1c1.9-.7,6.6-2.4,11.9-3.8c5.2-1.4,11-2.4,15.1-2c2.5.3,5.1,1.7,7.6,3.4c2.4,1.7,4.7,3.7,6.6,5.3c2.3,2,4.3,4.3,5.9,6.9c1.7,2.5,3.1,5.3,4,8.2q.1.1.1.3.1.1.1.2.1.4.2.8.1.5.2.9.2.7.2,1.4q0,.8-.2,1.5Z",
    fill: "url(#eCwuQE5mxSB107-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1986.5,1343.5c-2,.7-4.2,1.2-6.4,1.7-2.2.4-4.4.8-6.7,1.2q-.1.1-.3.1-.1,0-.2-.1-.1,0-.1,0q0-.1,0-.1c0-.8.7-1.3,1.8-1.5c1-.3,2.3-.4,3.5-.5q1.1-.2,2.2-.3t2.2-.2c.5,0,1.3-.1,2.1-.1.7,0,1.5-.1,1.9-.2Z",
    fill: "url(#eCwuQE5mxSB108-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1998.5,1353.9c-.1.8-.4,1.3-.7,1.6-.3.4-.8.7-1.5,1-.4.2-.8.3-1.3.4-.4,0-.9,0-1.4.1-1.7.1-3.6.1-5.5.1-2,0-3.9,0-5.4.1-1.3.1-2.6.2-3.9.3s-2.5.1-3.6.1c-.9.1-2.1.2-3.2.2s-2.2-.1-3-.3c-.9-.2-1.5-.7-2-1.4-.5-.6-.9-1.5-1-2.3q-.1-.4-.1-.7q0-.4.1-.7c.6,0,1.2,0,1.8.1.5,0,1.1.1,1.7,0c1.5,0,3.1-.1,4.6-.2c1.6,0,3.2-.1,4.7-.2c3.2-.3,8-1,12.1-1.7c4-.6,7.2-1.1,7.2-1.1q.1.4.2.8.1.5.2.9.2.7.2,1.4q0,.8-.2,1.5Z",
    opacity: 0.6,
    fill: "url(#eCwuQE5mxSB109-fill)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1945.2,1335.9c-1.7,2.9-3.6,6.1-5.2,9.6-1.6,3.4-3,7-3.7,10.6h-.4-.4c.6-3.6,2-7.4,3.6-10.9c1.7-3.5,3.6-6.8,5.4-9.8q.1-.1.3-.1.2-.1.3,0t.2.3q0,.1-.1.3Z",
    fill: "#ea8e67"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1954.2,1336.1c-1.9,3-3.8,6.3-5.4,9.6-1.7,3.3-3,6.8-3.7,10.1q-.2.1-.5.1-.2,0-.4,0c.7-3.4,2-7,3.7-10.4s3.6-6.8,5.5-9.9q.1-.1.3-.2.1,0,.3.1t.2.3q.1.1,0,.3Z",
    fill: "#ea8e67"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M1986.5,1343.4c0,0-.9.4-2.2.7s-2.8.6-3.9.6q-.7.1-1.3.1t-1.3.1q.1-.2.1-.3q0-.2-.1-.3q0-.4-.1-.8t-.2-.8c-.2-.7-.4-1.5-.7-2.3-.3-.7-.7-1.4-1.1-2-.7-.9-1.8-1.4-2.9-1.8-1.2-.3-2.4-.4-3.4-.3-1.8.1-3.3.8-4.6,1.7s-2.4,1.9-3,2.7c-1.7,1.9-3,3.9-4.2,5.9-1.3,1.9-2.5,3.8-4.1,5.7q-.4.3-.8.7-.3.4-.7.8-.2.3-.5.5t-.6.4-.6.2q-.4.1-.8.2t-.9.1q-.4.1-.8.2c1-1.5,2-3,2.8-4.4.9-1.5,1.6-2.8,2.2-4c1.1-2.3,2.8-5.2,4.6-7.7c1.8-2.6,3.7-4.8,5-5.5c1.6-.9,2.6-1.5,3.5-2s1.6-.8,2.5-1.1c1-.4,1.9-.7,2.7-.9s1.6-.3,2.4-.3c.6,0,1.2.1,1.7.3.6.2,1.1.5,1.7.8c1.7.9,3.4,1.9,5,3.1c1.6,1.3,2.9,2.7,3.8,4.5.4.6.8,1.6,1,2.6s.2,2-.2,2.6Z",
    opacity: 0.6,
    fill: "url(#eCwuQE5mxSB115-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1953,1352.3c.5-.4,1-1,1.6-1.6.5-.6,1-1.2,1.3-1.7.9-1.5,1.6-2.5,2.3-3.5.6-.9,1.2-1.8,1.9-2.8c1-1.5,3.7-2.9,6.7-3.4c3.1-.6,6.4-.3,8.7,1.5c1.1.9,1.6,1.8,1.8,2.7.3.9.2,1.6.2,2.2-1.9.4-3.6.8-5.2,1.2-1.7.5-3.1,1.2-4.6,2.2-.8.7-1.2,1.4-1.5,2.3-.2.8-.2,1.8-.2,2.6c0,.2.1.4.1.5.1.1.1.2.1.2-.1.1-.4.2-.8.3-.3,0-.7.1-1,.2q-1.1.2-2.2.3-1.1.2-2.3.2c-1.5.1-2.6.1-3.9.2-1.2,0-2.5-.1-4.6-.3-.7-.1-1.3-.2-1.7-.3-.5-.1-.8-.1-.8-.1s.5-.1,1.2-.5c.7-.5,1.7-1.2,2.9-2.4Z",
    fill: "url(#eCwuQE5mxSB116-fill)"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1720.5,1060.7l154,1.7l154.1,1.8l4.8-2.2l4.9-2.1-152.2-1.9-152.2-1.9-6.7,2.3-6.7,2.3Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1910.6,1352.7h3.1h3.1v-30.2-30.1h-3.1-3.1v30.1v30.2Z",
    fill: "#010019"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1720.4,1060.7l26.7,110.2l26.6,110.2l1.2,4.9l1.3,5l147.2,1.8l147.2,1.7-18.5-101.2-18.4-101.2-2.6-13.9-2.5-14-154.1-1.8-154.1-1.7Z",
    fill: "url(#eCwuQE5mxSB120-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1773.7,1281.1l1.2,4.9l1.3,5l147.2,1.8l147.2,1.7-18.5-101.2-18.4-101.2q-.7,2.4-1.4,4.8-.7,2.3-1.6,4.6c-5.1,13.6-11.9,26.7-19.7,39.1-7.7,12.5-16.5,24.3-25.8,35.3-12.1,14.4-25.6,28.3-40.2,40.9-14.7,12.5-30.5,23.6-47.3,32.1-15.8,8-31.7,14.5-48.1,19.6-16.3,5-33.2,8.6-50.9,10.7q-6.3.7-12.5,1.2t-12.5.7Z",
    fill: "#010019"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2070.6,1294.5l4.7-3l4.7-3.1-20.8-114.3-20.9-114.2-4.9,2.1-4.8,2.2l21,115.2l21,115.1Z",
    fill: "url(#eCwuQE5mxSB122-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1877.9,1180c.8,6.9,4,12.8,8.5,16.8c4.5,4.1,10.4,6.2,16.5,5.5c6.2-.7,11.4-4.1,14.9-9.1c3.5-4.9,5.3-11.4,4.5-18.3-.8-6.8-4-12.7-8.5-16.7-4.6-4.1-10.4-6.2-16.6-5.5-6.1.7-11.3,4.1-14.8,9.1-3.5,4.9-5.3,11.4-4.5,18.2Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1838.4,1234.1l.4,1.5.4,1.5h70.4h70.5l-.3-1.5-.3-1.5h-70.6-70.5Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1841,1244.2l.4,1.5.4,1.5h70.1h70.1l-.3-1.5-.3-1.5h-70.2-70.2Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1843.7,1254.9l.4,1.6.5,1.5h69.7h69.8l-.3-1.5-.4-1.6h-69.8-69.9Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1943.6,1356.3h-29.7-29.7c0-2.3,3.3-4.4,8.7-5.9s12.8-2.4,21-2.4s15.7.9,21,2.4c5.4,1.5,8.7,3.6,8.7,5.9Z",
    fill: "#010019"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M2313.5,1346.4h-136-136v5v5.1h136h136v-5.1-5Z",
    fill: "#010019"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1968.2,1357.5c-1,4.9-2.3,9.8-3.8,14.7-1.5,4.8-3.4,9.5-5.5,14.1s-4.5,8.9-7.2,13.1-5.8,8.2-9.1,11.8q-5.3,5.9-11.5,10.7t-13.1,8.5c-5.4,3-11,5.4-16.8,7.4s-11.7,3.6-17.7,4.8-12.1,2-18.2,2.3c-6.1.4-12.2.3-18.3-.3q-8.2-.8-16.3-2.7-8-1.9-15.7-5-7.2-2.8-13.9-6.4-6.7-3.7-12.9-8.2-5.8-4.2-11.1-9t-10-10.2q-4.3-4.8-8-10t-6.8-10.9c-1.7-3.1-3.2-6.4-4.6-9.8-1.3-3.3-2.4-6.8-3.2-10.3q-.2-1.1-.4-2.2t-.3-2.1q-.1-.6-.5-1-.3-.4-.9-.4c-.3,0-.7.2-.9.4-.3.3-.5.6-.4,1c.4,3.5,1.2,7,2.3,10.4c1,3.4,2.4,6.7,3.9,9.9q2.7,5.8,6.1,11.2t7.3,10.4q4.4,5.6,9.4,10.7q5,5,10.6,9.5q6,4.9,12.5,9q6.6,4.1,13.6,7.4q7.5,3.5,15.4,6t16.1,3.9q9,1.4,18.1,1.6q9.2.1,18.2-1.1c6.3-.8,12.6-2,18.8-3.7s12.2-3.8,18.1-6.4c5-2.2,9.9-4.8,14.5-7.9c4.7-3,9-6.3,13.1-10.1c3.7-3.5,7.2-7.3,10.3-11.4c3.1-4,5.9-8.3,8.4-12.8s4.7-9.2,6.5-14c1.9-4.8,3.5-9.8,4.8-14.8q.5-1.8.9-3.7.4-1.8.8-3.7c.2-.9-.3-1.5-1-1.7-.6-.1-1.4.1-1.6,1Z",
    fill: "url(#eCwuQE5mxSB133-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2188.1,1358.1q-2.4,6.6-5,13.1-2.5,6.6-5.3,13.1-3.5,8-7.4,15.8-4,7.9-8.5,15.4-5.1,8.5-11,16.5t-12.6,15.3c-4.9,5.3-10.2,10.4-15.7,15-5.6,4.6-11.5,8.9-17.7,12.7-6.9,4.4-14.3,8.1-21.8,11.3-7.6,3.2-15.4,5.8-23.3,7.8-9.5,2.4-19.2,4-29,4.9-9.7.8-19.5.8-29.3,0-9.9-.9-19.7-2.6-29.4-5-9.6-2.4-19-5.6-28.2-9.3-9-3.7-17.7-8.1-26.1-13-8.4-4.8-16.5-10.3-24.2-16.2-7.3-5.6-14.3-11.6-20.8-18.1-6.6-6.5-12.7-13.4-18.2-20.7q-3.9-5-7.3-10.3-3.5-5.3-6.6-10.8c-2.7-5.1-5.4-10.3-7.7-15.6s-4.2-10.7-5.6-16.3q-.2-.8-.4-1.6t-.4-1.6q-.1-.5-.2-.9-.2-.5-.3-1c0-.1-.1-.4-.1-.7c0-.2-.1-.4-.1-.1q-.1.3-.3.6t-.3.5q0,0,0,0t0,0q-.5-.1-.9-.2-.5-.1-1-.2c0-.1,0-.1,0,0c.1.1.1.2.2.3.2.8,1,1.1,1.7.9.6-.2,1.1-.8.9-1.6q-.1-.3-.2-.5-.1-.3-.2-.5c-.2-.3-.5-.5-.9-.6-.3-.1-.7-.1-1,.1-.8.6-.7,1.9-.4,3.2s.8,2.7,1,3.4q.9,3.6,2,7.1q1,3.5,2.4,7q3,7.2,6.6,14.2t7.7,13.6c4.9,7.7,10.3,15,16.3,22c5.9,6.9,12.4,13.4,19.1,19.5c7.3,6.5,15,12.5,23,18.1c8.1,5.5,16.5,10.5,25.1,15c9,4.5,18.2,8.5,27.7,11.8s19.2,5.9,29.1,7.7c10.1,1.9,20.2,2.9,30.3,3c10.2.2,20.4-.6,30.4-2.2c8.7-1.4,17.3-3.4,25.7-6c8.5-2.7,16.6-6,24.5-10c6.8-3.4,13.4-7.4,19.6-11.8c6.2-4.3,12.2-9.2,17.7-14.4c5.1-4.8,9.8-9.8,14.3-15.1c4.4-5.4,8.6-10.9,12.4-16.7q5.2-7.8,9.8-15.9q4.5-8.2,8.4-16.7q3.3-7.1,6.3-14.3q2.9-7.2,5.6-14.5.6-1.4,1.1-2.9.6-1.4,1.1-2.9c.3-.8-.2-1.4-.9-1.6-.6-.1-1.4.1-1.7.9Z",
    fill: "url(#eCwuQE5mxSB134-fill)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M2666.9,1361.7h-493.6-493.5v-3.6-3.6h493.5h493.6v3.6v3.6Z",
    fill: "url(#eCwuQE5mxSB135-fill)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2359.2,1403.1h105.9h105.9c1.9,0,3.6.8,4.8,2s2,2.9,2,4.8v20v19.9c0,1.9-.8,3.6-2,4.8s-2.9,2-4.8,2h-105.9-105.9c-1.9,0-3.6-.8-4.8-2s-1.9-2.9-1.9-4.8v-19.9-20c0-1.9.7-3.6,1.9-4.8s2.9-2,4.8-2Z",
    fill: "url(#eCwuQE5mxSB137-fill)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2528.1,1431.6c0,3.8,1.6,7.3,4.1,9.7c2.4,2.5,5.9,4.1,9.7,4.1s7.2-1.6,9.7-4.1c2.5-2.4,4.1-5.9,4.1-9.7s-1.6-7.2-4.1-9.7-5.9-4.1-9.7-4.1-7.3,1.6-9.7,4.1c-2.5,2.5-4.1,5.9-4.1,9.7Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2476.7,1431.6c0,3.8,1.5,7.3,4,9.7c2.5,2.5,6,4.1,9.8,4.1s7.2-1.6,9.7-4.1c2.5-2.4,4-5.9,4-9.7s-1.5-7.2-4-9.7-5.9-4.1-9.7-4.1-7.3,1.6-9.8,4.1-4,5.9-4,9.7Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2426.4,1431.6c0,3.8,1.5,7.3,4,9.7c2.5,2.5,5.9,4.1,9.7,4.1c3.9,0,7.3-1.6,9.8-4.1c2.5-2.4,4-5.9,4-9.7s-1.5-7.2-4-9.7-5.9-4.1-9.8-4.1c-3.8,0-7.2,1.6-9.7,4.1s-4,5.9-4,9.7Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2376.4,1431.6c0,3.8,1.6,7.3,4.1,9.7c2.4,2.5,5.9,4.1,9.7,4.1s7.2-1.6,9.7-4.1c2.5-2.4,4.1-5.9,4.1-9.7s-1.6-7.2-4.1-9.7-5.9-4.1-9.7-4.1-7.3,1.6-9.7,4.1c-2.5,2.5-4.1,5.9-4.1,9.7Z",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1738.2,769.8l80.6-.2l80.6-.2c8.9,0,16.8,3.9,22.1,10.1s8,14.5,6.7,23.3v.2l-.1.2c-1.1,7.1-4.6,13.2-9.8,17.6-5.1,4.4-11.7,7-18.9,7h-80.6-80.6c-8.9,0-16.8-4-22.1-10.3-5.3-6.2-8-14.7-6.5-23.5c1.2-7,4.8-13,9.9-17.4c5-4.3,11.6-6.8,18.7-6.8Z",
    fill: "#010019"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1889.2,736.3c2.3,6.2,6.9,10.8,12.5,13.4c5.5,2.5,12.1,3,18.3.7c6.1-2.3,10.8-6.9,13.4-12.5c2.5-5.5,3-12.1.7-18.3-2.3-6.1-6.9-10.8-12.5-13.4-5.5-2.5-12.1-3-18.3-.7s-10.8,6.9-13.4,12.5c-2.5,5.5-3,12.1-.7,18.3Z",
    fill: "#e53f53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1911.6,757.1c-8,0-15.3-3.3-20.5-8.6-5.3-5.2-8.6-12.5-8.6-20.5c0-8.1,3.3-15.4,8.6-20.6c5.2-5.3,12.5-8.6,20.5-8.6c8.1,0,15.4,3.3,20.6,8.6c5.3,5.2,8.6,12.5,8.6,20.6c0,8-3.3,15.3-8.6,20.5-5.2,5.3-12.5,8.6-20.6,8.6Zm0-57.4c-7.8,0-14.8,3.1-20,8.3-5.1,5.1-8.3,12.2-8.3,20s3.2,14.8,8.3,20c5.2,5.1,12.2,8.2,20,8.2s14.9-3.1,20-8.2c5.2-5.2,8.3-12.2,8.3-20s-3.1-14.9-8.3-20c-5.1-5.2-12.2-8.3-20-8.3Z",
    fill: "#fff",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1912.2,743.7c-.7,0-1.4-.3-1.9-.8s-.8-1.2-.8-2c0-.7.3-1.4.8-1.9s1.2-.8,1.9-.8c.8,0,1.5.3,2,.8s.8,1.2.8,1.9c0,.8-.3,1.5-.8,2s-1.2.8-2,.8Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1915,733.7h-2.6-2.6l-.4-11.4-.4-11.5h3.3h3.3l-.3,11.5-.3,11.4Z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M1740.9,871.1c0,0,4-3.7,9.6-8.9c5.5-5.2,12.5-11.9,18.5-18q.7.1,1.5.2.8,0,1.6,0h80.6h80.6c9,0,16.9-4,22.2-10.2c5.3-6.3,7.9-14.7,6.5-23.6-.6-3.4-1.8-6.7-3.5-9.6-1.7-3-3.8-5.6-6.4-7.7-2.5-2.2-5.4-3.9-8.6-5.1-3.2-1.1-6.6-1.8-10.1-1.8l-80.6-.2-80.7-.2c-8.9,0-16.7,4-22,10.2-5.3,6.1-8.1,14.5-6.7,23.3v.2.1c.7,4,2.1,7.7,4.2,11c2,3.3,4.7,6.1,7.8,8.3-1.7,3.7-3.4,7.3-5.2,10.9-1.7,3.6-3.3,7.3-4.9,11q-1,2.5-2.1,5.1-1,2.5-2.3,5Z",
    fill: "url(#eCwuQE5mxSB152-fill)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1778.1,815.3c0,2.9-1.1,5.5-3,7.4s-4.5,3-7.4,3c-2.8,0-5.4-1.1-7.3-3s-3.1-4.5-3.1-7.4s1.2-5.5,3.1-7.3c1.9-1.9,4.5-3.1,7.3-3.1c2.9,0,5.5,1.2,7.4,3.1c1.9,1.8,3,4.4,3,7.3Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1929.2,810.3h-67.8-67.9v-2-2.1h67.9h67.8v2.1v2Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1929.2,823h-67.8-67.9v-2.1-2h67.9h67.8v2v2.1Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2550.6,1311.8c.9-1.6,2.5-2.8,4.3-3.8c1.7-1,3.7-1.8,5.3-2.4c2.8-1,5.7-1.6,8.6-1.7c3-.2,5.9.1,8.8.8c2.5.6,5,1.4,7.4,2.7c2.3,1.2,4.5,2.7,6.1,4.8c2.1,2.6,2.5,5.9,1.9,9-.7,3.2-2.4,6.2-4.8,8.2-3.1,2.6-7.3,4.6-11.6,5.8-4.4,1.3-9,1.8-13,1.4-2.8-.3-8.1-1.7-11.8-3.9-3.7-2.3-5.8-5.5-2.4-9.3c2.3,3.7,6.7,5.9,11.3,6.6s9.6,0,13.1-2.3c1-.7,1.8-1.6,2.4-2.6.5-1.1.9-2.2,1-3.4c0-1.3-.2-2.6-.8-3.8-.5-1.2-1.3-2.3-2.3-3.1-1.5-1.3-3.3-1.9-5.1-2.1s-3.8.1-5.5.6c-2.2.6-4.6,1.7-6.9,3-2.2,1.3-4.4,2.7-6.1,4.2-.5-1.5-.8-3-.9-4.4c0-1.5.3-2.9,1-4.3Z",
    fill: "url(#eCwuQE5mxSB158-fill)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 0.906269 0 111.37284)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    id: "eCwuQE5mxSB160",
    d: "M2513.4,1289.1q0-.1,0-.2t0-.2q.2-1.9.4-3.9t.3-4c.6-6.3,2-12.5,3.8-18.5c1.9-6,4.3-11.9,7-17.6c3.6-7.5,8-14.6,12.2-21.8c4.3-7.2,8.4-14.4,11.3-22.2c2.5-6.9,4.2-15.4,4.2-23.9c0-8.4-1.8-16.7-6.1-23.2-5.5-8.4-13-8.1-19.5-3.9-6.4,4.1-12,12.1-13.7,18.8-.5,2-.7,4-.3,5.3.5,1.2,1.7,1.8,4,1.1s4.1-1.8,5.6-3.3c1.5-1.4,2.8-3.2,4.1-5c2.4-3.6,4.9-6.9,7.4-10.2c2.4-3.4,4.6-6.9,6.4-10.8c3-6.5,5.8-13.5,7.5-20.8c1.8-7.3,2.5-14.9,1.3-22.2-1.9-12.4-9.2-17.9-18.1-18.9-8.9-1.1-19.5,2.2-28.1,7.3-12,7-20.2,17.4-25.7,29.3s-8.3,25.3-9.6,38.5c-.6,6.8-.9,13.8-.4,20.8.5,6.9,1.7,13.8,3.9,20.3c1.8,5.1,3.9,10.1,6.2,15c2.3,5,4.7,9.8,7.3,14.5c4.1,7.4,8.3,15.4,11.8,23.6c3.5,8.3,6.3,16.7,7.4,25.1.2,1.8.4,3.7.7,5.5.2,1.8.5,3.6,1,5.4.1.6.3,1.1.5,1.6.2.6.5,1,1,1.4q.5.5,1.2.7t1.4.2t1.3-.1q.6-.2,1.1-.6c.4-.4.7-.8.9-1.4.2-.5.2-1.1.3-1.7Z",
    opacity: 0.7,
    fill: "url(#eCwuQE5mxSB160-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2553.6,1183.2c-.4,4.7-1.3,9.4-2.6,13.9-1.5,5.1-3.7,10-6.1,14.7-2.5,4.8-5.2,9.4-7.9,13.9-2.9,4.8-5.7,9.6-8.3,14.6-2.6,4.9-5,9.9-7,15.2q-1.5,4-2.8,8-1.2,4-2,8.2c-.6,2.8-1,5.7-1.3,8.6s-.6,5.8-.9,8.7q0,0,0,.1q0,0,0,0c-.1,1.3-.4,2.4-1,3.3-.6,1-1.5,1.6-2.9,1.8-1.2.2-2.4,0-3.5-.5-1-.5-1.8-1.4-2.3-2.5-.6-1.3-.9-2.6-1.2-4-.2-1.4-.3-2.8-.5-4.2q-.3-2.1-.6-4.3-.3-2.1-.7-4.2-.8-4.2-2-8.3t-2.7-8c-2.1-5.4-4.5-10.5-7-15.6-2.6-5.1-5.3-10.1-8-15.2q-2.1-3.8-4-7.7-2-3.9-3.7-7.9c-1.1-2.6-2.3-5.3-3.3-8.1-1.1-2.7-2-5.5-2.7-8.3-1.5-5.5-2.3-11.1-2.6-16.7-.3-5.7-.2-11.4.2-17c.8-9,2.1-18.2,4.6-27.1c2.4-8.8,5.9-17.3,11-25c4.5-6.7,10.3-12.8,17-17.5c6.8-4.8,14.4-8.1,22.5-9.4c3.2-.5,6.6-.7,9.8-.4c3.3.4,6.5,1.3,9.3,3c3.3,2,5.6,4.8,7.3,8s2.7,6.8,3.2,10.4c.7,5.6.4,11.3-.6,16.8-1,5.6-2.6,11-4.6,16.2q-1,2.7-2,5.2-1.1,2.5-2.3,5c1.8.9,3.4,2.3,4.8,3.9c1.3,1.6,2.4,3.5,3.4,5.3q1.5,3.1,2.4,6.4q1,3.3,1.4,6.6c.6,4.7.7,9.4.2,14.1Zm-2.3-7.7c-.1-4.5-.8-9-2.1-13.2-.8-2.4-1.9-5.1-3.4-7.4-1.5-2.4-3.4-4.4-5.7-5.6q-.3.6-.6,1.2-.3.5-.7,1.1c-1.4,2.4-3,4.6-4.6,6.9-1.6,2.2-3.3,4.4-4.9,6.7-1.4,1.8-2.6,3.8-4.1,5.6-1.5,1.7-3.1,3.3-5.2,4.3-.9.5-1.9,1-3,1.3-1,.2-2.1.3-3.1-.1-.9-.2-1.4-.8-1.8-1.5s-.6-1.5-.7-2.3c0-1.9.3-3.8.9-5.7.7-1.8,1.5-3.6,2.4-5.2q1.3-2.6,3.1-5q1.8-2.3,3.9-4.4c2.3-2.1,5-4.1,8-5.4c2.9-1.2,6.1-1.7,9.2-.8q1.3-2.6,2.4-5.2q1-2.7,2-5.4q1.5-3.8,2.6-7.7q1.1-4,1.8-7.9.7-4,.9-8.1.1-4-.4-8c-.3-1.8-.6-3.6-1.2-5.4-.6-1.7-1.3-3.4-2.3-5-3.5-5.7-9.2-8-15.2-8.4-6.1-.4-12.7,1.2-18,3.3-3.6,1.5-7.1,3.4-10.4,5.5-3.2,2.2-8.6,5.631013-11.3,8.431013-3.1,3-3.4,5.368987-5.8,8.968987-2.3,3.5-4.3,7.3-6,11.2-1.8,3.9-3.2,8-4.4,12.2s-2.1,8.4-2.9,12.7c-.8,4.8-1.4,9.6-1.8,14.5-.4,4.8-.5,9.7-.3,14.5q.1,4.1.6,8.1t1.4,7.9c.6,2.7,1.3,5.3,2.2,7.8.9,2.6,1.9,5.2,2.9,7.7c2.1,5,4.5,9.9,7,14.8c2.6,4.8,5.2,9.6,7.7,14.4s4.9,9.7,7.1,14.7c2.1,5,4,10.1,5.5,15.3.7,2.7,1.3,5.3,1.7,7.9.5,2.7.8,5.3,1.2,8q.2,1.1.3,2.2.2,1.1.4,2.2c.1.5.2,1.2.4,1.8.1.6.4,1.2.7,1.6.3.5.8.8,1.4.9.5.1,1.1.1,1.6-.1.5-.1.8-.4,1-.8.2-.3.3-.8.4-1.3q0-.1,0-.1t0-.1c.2-2.6.4-5.3.7-8c.2-2.7.6-5.3,1.1-7.9.9-5.3,2.4-10.6,4.2-15.6c1.8-5.1,3.9-10.1,6.3-14.9c2.3-4.7,4.9-9.3,7.6-13.8c2.6-4.5,5.3-8.9,7.9-13.5c2.3-4.2,4.4-8.4,6.2-12.8s3.2-8.9,4-13.6c.8-4.4,1.3-9,1.2-13.5Zm-15.2-27.3q-.8-.1-1.6,0c-1.6.2-3.1.7-4.6,1.4-1.4.7-2.8,1.6-4.1,2.6q-2.1,1.7-4,3.8-1.8,2-3.3,4.4-1.5,2.2-2.5,4.6-1.1,2.4-1.6,4.9c-.1.5-.3,1.3-.3,2.1s.1,1.5.5,1.8c.2.2.6.2,1,.1s.8-.2,1-.3q.8-.2,1.4-.5.7-.3,1.3-.6c2-1.2,3.5-2.8,4.8-4.6c1.4-1.8,2.6-3.8,3.9-5.6c1.5-2,3.1-4.1,4.6-6.2s3-4.2,4.3-6.5q.1-.3.3-.6t.4-.6q-.7-.2-1.5-.2Z",
    fill: "#fff",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M2465.1,1301.2q0,2.2.1,4.4q0,2.2.2,4.4c.4,5.2,1.6,10.4,3.6,15.4s4.7,9.8,8,14q2.2,3,4.8,5.6q2.5,2.6,5.4,4.8c4.7,3.5,10.7,5.6,16.9,6.4c6.1.7,12.4.1,17.8-1.8c4.8-1.6,9-3.8,12.8-6.5c3.8-2.8,7.3-6.1,10.5-10c2.4-3,4.1-6.5,5.4-10.2c1.4-3.7,2.2-7.5,2.7-11.3.5-3.7,1-7.3,1.2-11s.2-7.3-.3-11c-.2-1-.1-1.8-.2-2.4-.1-.7-.4-1.1-1.2-1.4-.6-.2-1.8-.3-3-.4-1.2,0-2.4,0-3.1,0q-.5,0-1,.1-.5,0-.9,0c-1.3,0-2.4-.1-3.8-.1s-3.2-.1-5.7,0c-4,.1-6.7.1-9.3.1s-5.3.1-9.2.2c-4.7.2-12.7.2-20.7.3-7.9,0-15.9,0-20.5.3-1.4,0-3.8-.2-6,.1-2.1.3-3.9,1.1-4.2,3.3-.1,1.4-.2,2.5-.2,3.6-.1,1.1-.1,2.1-.1,3.1Z",
    fill: "url(#eCwuQE5mxSB162-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2477,1339.4q2.2,3,4.8,5.6q2.5,2.6,5.4,4.8c4.7,3.5,10.7,5.6,16.9,6.4c6.1.7,12.4.1,17.8-1.8c4.8-1.6,9-3.8,12.8-6.5c3.8-2.8,7.3-6.1,10.5-10c2.4-3,4.1-6.5,5.4-10.2c1.4-3.7,2.2-7.5,2.7-11.3q.1-.8.2-1.6t.2-1.6c.4-3.5.8-7,.9-10.5s0-7.1-.5-10.6q-.1-.6-.4-.9-.3-.4-.9-.6c-.6-.2-1.8-.3-3-.4-1.2,0-2.4,0-3.1,0q-.5,0-1,.1-.5,0-.9,0c-.5,2.3-1,4.6-1.6,6.8-.6,2.3-1.3,4.6-2.3,6.8-1.6,3.5-3.9,7.1-6.6,10.4-2.6,3.4-5.7,6.4-8.7,8.9-6.8,5.3-14.6,9.3-22.8,12s-16.9,4.1-25.4,4.2h-.2-.2Z",
    fill: "url(#eCwuQE5mxSB163-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2469,1302.6c.1-.9.1-2,.2-3c.2-1,.4-2,.9-2.8.6-.9,1.5-1.5,2.5-1.9s2.1-.5,3.1-.6q.8,0,1.5.1.8,0,1.5.1c.6,0,1.2,0,1.8-.1.6,0,1.2,0,1.8.2s1.1.6,1.6,1.1c.4.5.7,1.1,1,1.6.8,1.8,1.3,3.8,1.6,5.8s.5,4,.6,5.9q.2,3.4.2,6.8-.1,3.4-.5,6.8c0,.6-.1,1.3-.3,1.8-.2.6-.6,1.2-1.1,1.5q-.4.4-1,.5-.5.1-1.1.1-1.6.1-3-.2-1.5-.4-2.9-1.1c-2-1.2-3.5-2.9-4.7-4.8-1.2-2-2.1-4.2-2.6-6.3q-.8-2.8-1.1-5.7-.2-2.9,0-5.8Z",
    fill: "url(#eCwuQE5mxSB164-fill)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2576.2,928.1v58v58c0,2-.9,3.8-2.2,5.1s-3.1,2.1-5.1,2.1h-60.3-60.3c-2,0-3.8-.8-5.1-2.1s-2.1-3.1-2.1-5.1v-58-58h67.5h67.6Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2576.2,920v4v4.1h-67.6-67.5v-4.1-4c0-2,.8-3.8,2.1-5.1s3.1-2.1,5.1-2.1h60.3h60.3c2,0,3.8.8,5.1,2.1s2.2,3.1,2.2,5.1Z",
    fill: "url(#eCwuQE5mxSB167-fill)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2467.4,920.4c0,.7.3,1.2.7,1.6s1,.7,1.6.7s1.2-.3,1.6-.7.7-.9.7-1.6c0-.6-.3-1.2-.7-1.6s-1-.7-1.6-.7-1.2.3-1.6.7-.7,1-.7,1.6Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2459.2,920.4c0,.7.3,1.2.7,1.6s1,.7,1.6.7s1.2-.3,1.6-.7.7-.9.7-1.6c0-.6-.3-1.2-.7-1.6s-1-.7-1.6-.7-1.2.3-1.6.7-.7,1-.7,1.6Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2451.2,920.4c0,.7.2,1.2.6,1.6.5.4,1,.7,1.7.7.6,0,1.2-.3,1.6-.7s.6-.9.6-1.6c0-.6-.2-1.2-.6-1.6s-1-.7-1.6-.7c-.7,0-1.2.3-1.7.7-.4.4-.6,1-.6,1.6Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M2552.2,960.3h-43.6-43.6v-2-2.1h43.6h43.6v2.1v2Z",
    fill: "#f29f05"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2552.2,969.2h-43.6-43.6v-2-2h43.6h43.6v2v2Z",
    fill: "#010019"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2494.5,978.2h-14.7-14.8v-2-2h14.8h14.7v2v2Z",
    fill: "#f29f05"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2552.2,987.2h-43.6-43.6v-2.1-2h43.6h43.6v2v2.1Z",
    fill: "#e53f53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2544.6,996.1h-39.8-39.8v-2-2h39.8h39.8v2v2Z",
    fill: "#010019"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2552.2,1014.2h-43.6-43.6v-2-2h43.6h43.6v2v2Z",
    fill: "#f29f05"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2552.2,1023.2h-43.6-43.6v-2-2.1h43.6h43.6v2.1v2Z",
    fill: "#ccc4cc"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2640.6,894.4v53.1v53.1c0,1.9-.8,3.7-2.1,5s-3.1,2.1-5,2.1h-59.1-59.1c-2,0-3.8-.8-5.1-2.1s-2.1-3.1-2.1-5v-53.1-53.1h66.3h66.2Z",
    fill: "#010019"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2640.6,886.5v3.9v4h-66.2-66.3v-4-3.9c0-2,.8-3.8,2.1-5.1s3.1-2,5.1-2h59.1h59.1c1.9,0,3.7.7,5,2s2.1,3.1,2.1,5.1Z",
    fill: "url(#eCwuQE5mxSB182-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2556,923.8h-12.9-12.9v-2-2h12.9h12.9v2v2Z",
    fill: "#ccc4cc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2618.5,934.6h-44.1-44.2v-1.9-2h44.2h44.1v2v1.9Z",
    fill: "#ccc4cc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2618.5,945.5h-44.1-44.2v-2-2h44.2h44.1v2v2Z",
    fill: "#ccc4cc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2618.5,956.4h-44.1-44.2v-2-2h44.2h44.1v2v2Z",
    fill: "#ccc4cc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2618.5,967.2h-44.1-44.2v-1.9-2h44.2h44.1v2v1.9Z",
    fill: "#ccc4cc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2618.5,978.1h-44.1-44.2v-2-2h44.2h44.1v2v2Z",
    fill: "#ccc4cc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2618.5,989h-44.1-44.2v-2-2h44.2h44.1v2v2Z",
    fill: "#ccc4cc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2664.1,1003.3c0,1-.3,2-1.1,2.8q-.6.6-1.3.9-.8.3-1.6.3-.7,0-1.5-.3-.7-.3-1.3-.9l-8.6-8.5-8.5-8.6c-2.4,1.7-5,3.1-7.7,4-2.8.9-5.7,1.4-8.7,1.4-3.6,0-7.2-.7-10.5-2.1-3.3-1.3-6.3-3.3-8.9-5.9s-4.6-5.6-6-8.9c-1.3-3.3-2-6.9-2-10.5c0-3.7.7-7.3,2-10.5c1.4-3.3,3.4-6.3,6-8.9c5.4-5.4,12.4-8.1,19.4-8.1s14.1,2.7,19.4,8.1c2.6,2.6,4.6,5.6,6,8.9c1.4,3.2,2.1,6.8,2.1,10.5c0,3-.5,5.9-1.4,8.6-1,2.8-2.3,5.4-4.1,7.7l8.6,8.6l8.6,8.6c.8.8,1.1,1.8,1.1,2.8ZM2616.4,985c2.3.9,4.8,1.4,7.4,1.4s5.1-.5,7.5-1.4c2.3-1,4.4-2.4,6.3-4.3c1.8-1.8,3.2-4,4.2-6.3s1.5-4.8,1.5-7.4-.5-5.1-1.5-7.5c-1-2.3-2.4-4.4-4.2-6.3-1.9-1.9-4.1-3.3-6.5-4.2-2.3-1-4.8-1.5-7.3-1.5s-5,.5-7.3,1.5c-2.3.9-4.5,2.3-6.4,4.2s-3.3,4-4.3,6.3c-.9,2.4-1.4,4.9-1.4,7.5s.5,5.1,1.4,7.4c1,2.3,2.4,4.5,4.3,6.3c1.8,1.9,3.9,3.3,6.3,4.3Z",
    fill: "#fff",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2489.8,890.5c2.2,6.1,6.7,10.7,12.2,13.2c5.4,2.5,11.8,2.9,17.9.7c6.1-2.3,10.6-6.8,13.1-12.2c2.5-5.5,3-11.9.7-18-2.2-6-6.7-10.6-12.2-13.1-5.4-2.5-11.9-3-17.9-.7-6.1,2.2-10.7,6.7-13.2,12.2s-2.9,11.9-.6,17.9Z",
    fill: "#e53f53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2511.7,910.9c-7.8,0-15-3.2-20.2-8.3-5.1-5.2-8.3-12.3-8.3-20.2s3.2-15,8.3-20.2c5.2-5.2,12.4-8.4,20.2-8.4c7.9,0,15,3.2,20.2,8.4s8.4,12.3,8.4,20.2-3.2,15-8.4,20.2c-5.2,5.1-12.3,8.3-20.2,8.3Zm0-56.3c-7.6,0-14.6,3.1-19.6,8.2-5,5-8.1,11.9-8.1,19.6c0,7.6,3.1,14.6,8.1,19.6s12,8.1,19.6,8.1c7.7,0,14.6-3.1,19.6-8.1c5.1-5,8.2-12,8.2-19.6c0-7.7-3.1-14.6-8.2-19.6-5-5.1-11.9-8.2-19.6-8.2Z",
    fill: "#fff",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M2512.3,897.8c-.8,0-1.4-.3-1.9-.8s-.8-1.1-.8-1.9c0-.7.3-1.4.8-1.9s1.1-.8,1.9-.8c.7,0,1.4.3,1.9.8s.8,1.2.8,1.9c0,.8-.3,1.4-.8,1.9s-1.2.8-1.9.8Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2515,888h-2.5-2.6l-.4-11.2-.4-11.2h3.3h3.2l-.3,11.2-.3,11.2Z",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1975.9,885.3c.2,3.3-.2,6.6-1.4,9.7-1.2,3-3.1,5.8-5.4,8-2.4,2.2-5.2,3.9-8.4,4.9-1.9.6-4,.8-6,.9-2.1.1-4.1,0-6.2,0q-2.1,0-4.3,0-2.1,0-4.3,0q.8,1.6,1.5,3.3.8,1.6,1.5,3.2c.6,1.3,1.2,2.7,1.7,4.1.6,1.3,1.2,2.7,1.8,4c.3.6.1,1.1-.3,1.4-.4.4-1,.4-1.5,0q-.3-.4-.7-.7-.3-.3-.7-.6-3.8-3.6-7.6-7.2-3.8-3.7-7.5-7.5-.1,0-.2,0-.2,0-.3,0-1.9,0-3.8,0t-3.8,0q-3.3,0-6.5,0-3.3,0-6.6,0-4,0-8.1,0-4,0-8.1,0-4.3,0-8.6,0-4.2,0-8.5,0-3.9,0-7.7,0-3.9,0-7.8,0-2.9,0-5.8,0-3,0-5.9,0-1.4,0-2.8,0-1.3,0-2.7,0c-3.2,0-6.4-.7-9.3-2-2.9-1.4-5.5-3.4-7.5-5.9-2.5-3-4.1-6.7-4.7-10.5-.5-3.8-.1-7.8,1.4-11.5c1.6-3.6,4.1-6.7,7.2-9s6.8-3.7,10.7-4.1q1.2-.1,2.4-.1t2.4,0q2.1,0,4.1,0q2.1,0,4.2,0q3.2,0,6.3,0q3.2,0,6.3,0q3.9,0,7.8,0q3.8,0,7.7,0q4.2,0,8.5,0q4.2,0,8.4,0t8.5,0q4.2,0,8.5,0q3.9,0,7.8,0t7.9,0q3.2,0,6.4,0t6.4,0q2.2,0,4.4,0t4.4,0q.8,0,1.6,0q.9,0,1.7,0c3.7,0,7.3,1,10.5,2.8c3.2,1.7,6,4.3,7.9,7.5c1.7,2.8,2.8,6,3.1,9.3Zm-2.5-1.1c-.5-3-1.7-5.9-3.5-8.4-1.8-2.4-4.1-4.4-6.8-5.7-2.7-1.4-5.7-2.1-8.7-2.1q-.3,0-.5,0t-.4,0q-1.7,0-3.4,0-1.6,0-3.3,0-3,0-6,0t-6,0q-3.9,0-7.8,0t-7.8,0q-4.4,0-8.8,0t-8.8,0q-4.5,0-9,0t-9,0q-4.1,0-8.3,0t-8.4,0q-3.4,0-6.9,0-3.4,0-6.9,0-2.3,0-4.6,0t-4.6,0q-1.3,0-2.5-.1-1.2,0-2.4.1c-4,.4-7.7,2-10.7,4.6-3,2.5-5.2,5.9-6.2,9.8s-.8,7.9.6,11.6c1.4,3.6,3.8,6.9,7.1,9.2q2.5,1.6,5.2,2.5q2.8.8,5.7.8.4,0,.7,0t.6,0q2.2,0,4.3,0q2.2,0,4.3,0q3.6,0,7.2,0t7.2,0q4.4,0,8.7,0q4.4,0,8.7,0q4.5,0,9,0q4.4,0,8.9,0q3.8,0,7.7,0q3.8,0,7.6,0q2.6,0,5.2,0t5.1,0q.6,0,1.2,0t1.2,0q.1,0,.1,0q.1,0,.2,0c.5.1.9.4,1.2.7.4.4.7.8,1,1.1q.5.5,1.1,1.1.5.5,1,1q2.3,2.3,4.6,4.4q2.3,2.2,4.6,4.3-.3-.6-.6-1.3t-.6-1.4q-.9-2-1.9-4-.9-2.1-1.9-4.1c-.2-.4-.1-.9,0-1.2.2-.3.5-.6,1-.6q2.8,0,5.7,0q2.8,0,5.6,0c1.9,0,3.8.1,5.7,0s3.8-.4,5.6-1c2.8-1,5.4-2.7,7.4-4.8c2.1-2.1,3.7-4.7,4.6-7.5c1-2.9,1.2-6,.7-9Z",
    fill: "url(#eCwuQE5mxSB199-fill)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1858.2,888.6c0,1.3-.5,2.4-1.4,3.2-.8.8-1.9,1.3-3.1,1.3-1.3,0-2.4-.5-3.2-1.3s-1.3-1.9-1.3-3.2c0-1.2.5-2.3,1.3-3.1s1.9-1.3,3.2-1.3c1.2,0,2.3.5,3.1,1.3.9.8,1.4,1.9,1.4,3.1Z",
    fill: "url(#eCwuQE5mxSB200-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1890.5,888.6c0,1.3-.5,2.4-1.3,3.2s-2,1.3-3.2,1.3-2.4-.5-3.2-1.3-1.3-1.9-1.3-3.2c0-1.2.5-2.3,1.3-3.1s2-1.3,3.2-1.3s2.4.5,3.2,1.3s1.3,1.9,1.3,3.1Z",
    fill: "url(#eCwuQE5mxSB201-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1890.5,888.6c0,1.3-.5,2.4-1.3,3.2s-2,1.3-3.2,1.3-2.4-.5-3.2-1.3-1.3-1.9-1.3-3.2c0-1.2.5-2.3,1.3-3.1s2-1.3,3.2-1.3s2.4.5,3.2,1.3s1.3,1.9,1.3,3.1Z",
    fill: "url(#eCwuQE5mxSB202-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1922.8,888.6c0,1.3-.5,2.4-1.3,3.2s-1.9,1.3-3.2,1.3c-1.2,0-2.3-.5-3.1-1.3-.9-.8-1.4-1.9-1.4-3.2c0-1.2.5-2.3,1.4-3.1.8-.8,1.9-1.3,3.1-1.3c1.3,0,2.4.5,3.2,1.3s1.3,1.9,1.3,3.1Z",
    fill: "url(#eCwuQE5mxSB203-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1922.8,888.6c0,1.3-.5,2.4-1.3,3.2s-1.9,1.3-3.2,1.3c-1.2,0-2.3-.5-3.1-1.3-.9-.8-1.4-1.9-1.4-3.2c0-1.2.5-2.3,1.4-3.1.8-.8,1.9-1.3,3.1-1.3c1.3,0,2.4.5,3.2,1.3s1.3,1.9,1.3,3.1Z",
    fill: "url(#eCwuQE5mxSB204-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1955.1,888.6c0,1.3-.5,2.4-1.3,3.2s-1.9,1.3-3.2,1.3c-1.2,0-2.3-.5-3.1-1.3s-1.3-1.9-1.3-3.2c0-1.2.5-2.3,1.3-3.1s1.9-1.3,3.1-1.3c1.3,0,2.4.5,3.2,1.3s1.3,1.9,1.3,3.1Z",
    fill: "url(#eCwuQE5mxSB205-fill)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNot3);
export default __webpack_public_path__ + "static/media/not3.83fb41038919092867891d5f6af9ddef.svg";
export { ForwardRef as ReactComponent };